/* eslint-disable no-alert */
/* eslint-disable no-case-declarations */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-debugger */
/* eslint-disable radix */
/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { AddIcon, MinusIcon } from '@chakra-ui/icons'

import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  Radio as ChakraRadio,
  Flex,
  Heading,
  List,
  ListIcon,
  ListItem,
  RadioGroup,
  SimpleGrid,
  Spinner,
  Stack,
  Tab,
  Table,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tooltip,
  Tr,
  useBreakpointValue,
  useToast,
  VStack
} from '@chakra-ui/react'
import format from 'date-fns/format'
import parserElement from 'html-react-parser'
import lodash from 'lodash'
import { useSubscription } from 'mqtt-react-hooks'
import React, { useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { AiFillLock, AiFillUnlock } from 'react-icons/ai'
import { BiErrorCircle } from 'react-icons/bi'
import { FcInfo } from 'react-icons/fc'
import { FiDollarSign, FiEdit, FiInfo, FiPrinter, FiUser } from 'react-icons/fi'
import { MdFreeCancellation, MdSettingsAccessibility, MdSpeakerNotes } from 'react-icons/md'
import { Link, useHistory, useParams } from 'react-router-dom'
import { Card } from '../../components/Cards/card'
import { Input } from '../../components/Form/Input'
import { ModalCreateNewCard } from '../../components/Modal/confirmNewCard'
import { CardContainer } from '../../components/molecules/CardContainer'
import { WebcamCapture } from '../../components/Webcam'
import { ImageComponent } from '../../components/Webcam/ImageComponent'
import { StateOptions } from '../../utils/json/states'
import Dropzone from './Dropzone'

import { AddRecordUniq } from '../../components/AddRecordingUniq'
import { ArrowBack } from '../../components/atoms/arrowBack'
import InfoTooltipCard from '../../components/Cards/tooltipCard'
import { InputPhone2 } from '../../components/Form/InputPhone2'
import { Select } from '../../components/Form/Select'
import { SelectComponent } from '../../components/Form/SelectComponent'
import { SelectComponentAsync } from '../../components/Form/SelectComponentAsync'
import { Switch } from '../../components/Form/Switch'
import { MasksTypes, TextFieldControlled } from '../../components/Form/TextFieldControlled'
import { Header } from '../../components/Header'
import { ModalArrivedTime } from '../../components/Modal/confirmArrivedTime'
import { ModalConfirmExclude } from '../../components/Modal/confirmExclude'
import { ModalWebcam } from '../../components/Modal/modalWebcam'
import { NotFound } from '../../components/molecules/NotFound'
import { MultiSelectMenuFilter } from '../../components/MultiSelectFilters'
import { NotesModal } from '../../components/NotesModal'
import { Pagination } from '../../components/PaginationNew'
import { PermissionComponent } from '../../components/Permissions'
import { PrintButton } from '../../components/PrintButton'
import { Sidebar } from '../../components/Sidebar'
import { useAuth } from '../../hooks/auth'
import { NotesData } from '../../hooks/notes/useNotes'
import { useDocument } from '../../hooks/useDocument'
import { useModal } from '../../hooks/useModal'
import { apiAuth } from '../../services/apiAuth'
import { formatBrOrDollarDefault } from '../../utils/fns/formatBrOrDollarDefault'
import { remaskCaractersAll } from '../../utils/fns/removeCaracters'
import { mask } from '../../utils/mask'
import { useAddress } from '../../utils/services/useAddress'
import { formatDateBR, formatHour } from '../../utils/timezone'
import { useCustomers } from './logic'
import { usePatients } from './service'

// form values
type FormData = {
  occupation: string
  is_active: string
  alerts: string
  observation: string
  state: string
  cep: string
}

// indications service data
type ServicesData = Array<{
  value: number
  label: string
}>

type GetResponseDefaultData = Array<{
  name: string
  id: number
}>

interface Sections {
  id: number
  session_number: number
  status: number
  description: string | null
  attendance_id: number
  service_id: number
  service_name: string
  total_session: number
}

// client
export type FormClientData = {
  name: string
  nascimento: string
  idade: string
}

type ContactsData = {
  contact: string
  ddi_country: string
  id: string
  description: string
}

interface MedicalRecords {
  id?: number
  attendance_id: number
  start_date: string
  finish_date: string
  exams?: Array<{
    id?: number
    name: string
    information: string
  }>
  forms?: Array<{
    id: number | string
    information: string | null
    name: string
    questions?: Array<{
      answer: string
      is_multiple: boolean
      is_required: boolean
      options?: string
      question: string
    }>
  }>
  indications?: Array<{
    id: number
    indication_date: string | null
    observation: string
    service: {
      id: number
    }
    service_name: string
    status: number
  }>
  prescriptions?: Array<{
    id?: number
    name: string
    information: string
  }>
  services_not_performed:
    | []
    | Array<{
        service_id: number
        service_name: string
        description: string
        service: {
          id: number
          name: string
          observation: string
          is_active: boolean
          price: string
          days_to_come_back: 0
          days_to_maturity: 0
          protocol: string
          service_sessions: Array<{}>
        }
      }>
  services_performed:
    | []
    | Array<{
        service_id: number
        service_name: string
        total_session: number
      }>
  sessions_not_performed:
    | []
    | Array<{
        id: number
        session_number: number
        status: number
        description: string | null
        attendance_id: number
        service_id: number
        service_name: string
        total_session: number
      }>
  sessions:
    | []
    | Array<{
        id: number
        session_number: number
        status: number
        description: string | null
        attendance_id: number
        service_id: number
        service_name: string
        total_session: number
      }>
  specialist: {
    id: number
    social_name: string
  }
}

interface Records {
  id?: number
  start_date: string
  finish_date: string
  exams?: Array<{
    id?: number
    name: string
    information: string
  }>
  forms?: Array<{
    id: number | string
    information: string | null
    name: string
    questions?: Array<{
      answer: string
      is_multiple: boolean
      is_required: boolean
      options?: string
      question: string
    }>
  }>
  indications?: Array<{
    id: number
    indication_date: string | null
    observation: string
    service: {
      id: number
    }
    service_name: string
    status: number
  }>
  prescriptions?: Array<{
    id?: number
    name: string
    information: string
  }>
  specialist: {
    specialist_id: number
    specialist_social_name: string
  }
}

type GetRecordsData = Array<Records>

type GetMedicalRecordsData = Array<MedicalRecords>

type MedicalRecordsData = Array<MedicalRecords>

interface ParamsProps {
  id: string
}

type EmailsData = {
  id: string
  email: string
  description: string
}

interface Client {
  id: string
  hash: string
  name: string
  is_active: boolean
  allow_whatsapp: boolean
  allow_note: boolean
  image: string
  birth_date: string
  social_name: string
  sex: number
  document: Documents
  document_number: string
  documents: Array<DocumentClient>
  observation: string
  alerts: string
  ocuppation: string
  patient_tags: Array<number>
  origins: Array<number>
  role: string
  address: {
    zip_code: string
    street: string
    district: string
    city: string
    country: string
    state: string
    number: string
    observation: string
  }
  created_by: {}
  update_by: {}
}

type DocumentSelect = {
  label: string
  value: number
  regex: string
}

type Documents = {
  id: number
  name_ptbr: string
  name_en: string
  acronym: string
  index: Number
  regex: MasksTypes
}

type DocumentClient = {
  acronym: string
  id: number
  index: Number
  is_required: boolean
  is_view: boolean
  name_en: string
  name_es: string
  name_ptbr: string
  regex: MasksTypes
  value: string
  valueMask: string
}

type ClinicData = {
  patient_birth_date: boolean
  patient_document: boolean
  patient_origin: boolean
  patient_email: boolean
  hours_attendance_start: null | number
  hours_attendance_cancel: null | number
  hours_attendance_finish: null | number
  adding_itens_to_attendance: boolean
  documents: Documents[]
  documents_preferences: Array<any>
}

type DocumentsOptions = Array<{
  label: string
  value: number
  regex: any
}>

type ClientData = Client | null

type ActionsWs =
  | 'cancel-attendance'
  | 'finish-attendance'
  | 'allow-start-attendance'
  | 'logout-user'
  | 'patient-updated'
  | undefined

interface Attendance {
  id: number
  guide: number
  patient_id: number
  edit_status: 1 | 2 | 3
  hash: string
  allowed_start_attendance: boolean
  notes: NotesData[]
  block_checkout: boolean
  status_by_system: boolean
  scheduled_arrival_time: string
  scheduled_initial_time: string
  scheduled_final_time: string
  real_arrival_time: string
  real_initial_time: string
  real_final_time: string
  status: number
  professional_id: number
  attendance_spot_id: number
  observation: string
  observation_payment: string
  value_to_income: number
  patient_number?: string
  invoice_number: number | null
  invoice_date: string | null
  block_guide: boolean
  is_active: boolean
  specialist_name: string | null
  patient_name: string | null
  sessions: Array<{
    id: number
    session_number: number
    status: number
    description: string | null
    attendance_id: number
    service_id: number
    service_name: string
    total_session: number
  }>
  sessions_not_performed: Array<{}>
  indications: Array<{}>
  patient_social_name: string | null
  attendance_items_exclude?: Array<number>
  specialist_color: null | string
  ticket_status_payment?: number | null
  attendance_items: Array<{
    id: number
    service_name: string
    service_id: number
    total_session: number
  }>
  attendance_spot: {
    id: number
    index: number
    name: string
    is_active: boolean
  }
}

type AttendanceData = Array<Attendance>

type GetAttendances = {
  results: Array<Attendance>
  count: number
}

interface GalleryCard {
  id: string
  date: string
  name: string
  quantity_images: number
  quantity_videos: number
  quantity_documents: number
}

type GalleryCardData = Array<GalleryCard> | null

type Template = {
  id: number
  name: string
}

type Templates = Array<Template>

type IndicationsDataInfo = Array<{
  id: number
  service: {
    id: number
    name: string
  }
  service_name: string
  observation: string | null
  status: number
  indication_date: string | null
  specialist_name: string
  medical_record_finish_date: string
  updated_at: string
  updated_by_name: string | null
}>

type BudgetsDataInfo = Array<{
  id: number
  code: number
  due_date: string
  created_by: {
    id: number
    social_name: string
  }
  specialist: {
    id: number
    name: string
    social_name: string
  } | null
  patient: {
    id: number
    name: string
    social_name: string
  }
  created_at: string
  total: number
  items: [
    {
      id: number
      service: {
        id: number
        name: string
      }
      service_name: string
      sessions: number
      quantity: number
      unit_value: number
      discount_percent: number
      discount_absolute: number
      subtotal: number
    }
  ]
}>

// debounce
const timer: any = null

type BackSource =
  | 'clients'
  | 'attendance'
  | 'schedule'
  | 'gallery'
  | 'checkout'
  | 'medicalRecord'
  | 'budget'
  | 'unknown'

type BackContext = {
  source?: BackSource
  label: string
  path: string
  description?: string
  useBrowserBack?: boolean
}

type LocationData = {
  backContext?: BackContext

  isBackAttendance?: boolean
  id?: number | string | null
  state?: Attendance
  name?: string | number
}

type FiltersIndicationsData = {
  specialistIds: Array<string | number>
  status: Array<string | number>
  orderBy: string
}

type FiltersBudgetsData = {
  specialistIds: Array<string | number>
  date: string
}

export function UpdateClientsInfos() {
  const [t] = useTranslation('pageClients')
  const toast = useToast()
  const lastSavedImageRef = React.useRef('')
  const { decodeToken, clinicId } = useAuth()
  const { clinic_language } = decodeToken
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  })
  const { imgSrc, setImgSrc, imgFile } = useDocument()
  const params = useParams<ParamsProps>()
  const {
    calculateAge,
    healthInsurance,
    handleInputConvenio,
    handleSelectConvenio,
    addFieldsConvenio,
    removeFieldsConvenio,
    patientRelatives,
    addFieldsRelatives,
    removeFieldsRelatives,
    handleSelectedRelativesNames,
    handleSelectRelativesFamily,
    handleSelectedTags,
    handleSelectedOrigins,
    setPatientsTags,
    setPatientsOrigins,
    patientsTags,
    patientsOrigins,
    setHealthInsurance,
    setPatientRelatives
  } = useCustomers()
  const { tabIndexClient, setTabIndexClient, LocaleApp } = useModal()
  const today = format(new Date(), 'yyyy-MM-dd', {
    locale: LocaleApp
  })
  const address = useAddress()
  const history = useHistory<LocationData>()
  const clientService = usePatients()
  const tagsUpdate = clientService.tagsServices
  const optionsFamily = [
    {
      value: 1,
      label: `${t('pageClients.PageNovoCliente.containerFour.seletedPar.pai')}`
    },
    {
      value: 2,
      label: `${t('pageClients.PageNovoCliente.containerFour.seletedPar.mae')}`
    },
    {
      value: 3,
      label: `${t('pageClients.PageNovoCliente.containerFour.seletedPar.irma')}`
    },
    {
      value: 4,
      label: `${t('pageClients.PageNovoCliente.containerFour.seletedPar.tio')}`
    },
    {
      value: 5,
      label: `${t('pageClients.PageNovoCliente.containerFour.seletedPar.outros')}`
    }
  ]
  const originsUpdate = clientService.originsServices
  const covenantsUpdate = clientService.covenantsServices
  // states page
  const [localMethod, setLocal] = useState('')
  const [state, setState] = useState<ClientData>(null)
  const [isViewModalNote, setIsViewModalNote] = useState(false)
  const [notes, setNotes] = useState<NotesData[]>([])
  const [patientName, setPatientName] = useState('')
  const [allowNotes, setAllowNotes] = useState(false)
  const { state: oldLocation } = history.location

  const getBackContext = (): BackContext => {
    if (oldLocation?.backContext) {
      return oldLocation.backContext
    }

    if (oldLocation?.isBackAttendance && oldLocation?.id) {
      return {
        source: 'attendance',
        label: 'Voltar para o atendimento',
        path: `/attendance/${oldLocation.id}`,
        description: 'Você retornará para o atendimento'
      }
    }

    return {
      source: 'clients',
      label: 'Voltar para clientes',
      path: '/clients',
      description: 'Você retornará para a listagem de clientes'
    }
  }

  const backContext = getBackContext()

  // Form
  const { register, handleSubmit, formState, getValues } = useForm<FormData>({})
  const { errors } = formState

  // states cadastro
  const [ageUser, setAgeUser] = useState('')
  const [is_active, setIsActive] = useState(false)
  const [is_accept, setIsAccept] = useState(false)
  const [documents, setDocuments] = useState<DocumentsOptions>([])
  const [valueDocumentSelect, setValueDocumentSelect] = useState<DocumentSelect | null>(null)
  const [typeDocument, setTypeDocument] = useState<any>(null)
  const [numberDocument, setNumberDocument] = useState('')
  const [emailIsRequired, setEmailIsRequired] = useState(false)

  const [numbers, setNumbers] = useState<ContactsData[]>([
    {
      contact: '',
      ddi_country: decodeToken?.clinic?.clinic_contacts[0]?.ddi_country || '+55',
      id: '',
      description: ''
    }
  ])
  const [numbersWhats, setNumbersWhats] = useState<ContactsData[]>([
    {
      contact: '',
      ddi_country: decodeToken?.clinic?.clinic_contacts[0]?.ddi_country || '+55',
      id: '',
      description: ''
    }
  ])
  const [name, setName] = useState('')
  const [sex, setSex] = useState('')
  const [birth_date, setBirthDate] = useState('')
  const [socialName, setSocialName] = useState('')
  const [documentsClient, setDocumentsClient] = useState<DocumentClient[]>([])
  const [clinicData, setClinicData] = useState<ClinicData | null>(null)
  const [redirect, setRedirect] = useState(false)
  const [emails, setEmails] = useState<EmailsData[]>([
    {
      id: lodash.uniqueId(),
      email: '',
      description: ''
    }
  ])
  // address state
  const [numberAddress, setNumberAddress] = useState('')
  const [cepAddress, setCepAddress] = useState('')
  const [complement, setComplement] = useState('')
  const [occupation, setOccupation] = useState('')
  const [stateAddress, setStateAddress] = useState('')
  const [observationClient, setObservationClient] = useState('')
  const [alertsClient, setAlertsClient] = useState('')
  // change and warning message
  const [messageChangeForSave, setMessageChangeForSave] = useState(false)
  const [isOpenChangeMessage, setIsOpenChangeMessage] = useState(false)
  const [isLoadingOperation, setIsLoadingOperation] = useState(false)
  const [frontendModel, setFrontendModel] = useState(0)
  const [isCadastroHydrated, setIsCadastroHydrated] = useState(false)
  const [isAutoSaving, setIsAutoSaving] = useState(false)
  const [lastSavedAt, setLastSavedAt] = useState<Date | null>(null)
  const [autoSaveError, setAutoSaveError] = useState<string | null>(null)
  const cadastroAutoSaveTimer = React.useRef<ReturnType<typeof setTimeout> | null>(null)
  const lastCadastroPayloadKey = React.useRef('')
  const lastAutoSaveSuccessToastAt = React.useRef(0)
  const lastAutoSaveErrorToastAt = React.useRef(0)
  const lastAutoSaveErrorMessage = React.useRef('')
  const isImageInitializedRef = React.useRef(false)
  const isApplyingPatientMqttRef = React.useRef(false)
  const lastAppliedTagsKeyRef = React.useRef('')
  const dirtyRefs = React.useRef<Record<string, boolean>>({
    cadastro: false,
    telephones: false,
    telephonesWhatsapp: false,
    emails: false,
    healthInsurances: false,
    parents: false,
    addresses: false
  })
  const mainPatchAutoSaveTimer = React.useRef<ReturnType<typeof setTimeout> | null>(null)
  const pendingMainPatchRef = React.useRef<Record<string, any>>({})
  const mainSaveSeqRef = React.useRef(0)
  const latestAppliedMainSaveSeqRef = React.useRef(0)
  const lastLocalMainPatchRef = React.useRef<{
    at: number
    payload: Record<string, any>
  } | null>(null)
  const cadastroFormRef = React.useRef<HTMLDivElement | null>(null)
  const isCadastroFieldFocusedRef = React.useRef(false)
  const pendingPatientRealtimeRefreshRef = React.useRef(false)
  const lastFlushedMainPatchKeyRef = React.useRef('')
  const pendingRelationPayloadKeyRef = React.useRef<Record<string, string>>({
    telephones: '',
    telephonesWhatsapp: '',
    emails: '',
    healthInsurances: '',
    parents: '',
    addresses: ''
  })
  const relationAutoSaveTimers = React.useRef<Record<string, ReturnType<typeof setTimeout> | null>>(
    {
      telephones: null,
      telephonesWhatsapp: null,
      emails: null,
      healthInsurances: null,
      parents: null,
      addresses: null
    }
  )
  const lastRelationPayloadKey = React.useRef<Record<string, string>>({
    telephones: '',
    telephonesWhatsapp: '',
    emails: '',
    healthInsurances: '',
    parents: '',
    addresses: ''
  })
  const autoSaveSavingToastId = 'cadastro-autosave-saving'
  // style button selected
  const selectedButton = {
    border: '1px solid #031f35',
    background: '#fff',
    color: '#000'
  }

  const markCadastroAsChanged = () => {
    if (isCadastroHydrated && tabIndexClient === 0 && !isApplyingPatientMqttRef.current) {
      dirtyRefs.current.cadastro = true
      setMessageChangeForSave(true)
      setAutoSaveError(null)
    }
  }

  const markRelationAsChanged = (key: keyof typeof dirtyRefs.current) => {
    if (isCadastroHydrated && tabIndexClient === 0 && !isApplyingPatientMqttRef.current) {
      dirtyRefs.current[key] = true
      setMessageChangeForSave(true)
      setAutoSaveError(null)
    }
  }

  const showAutoSaveSavingToast = () => {
    if (!toast.isActive(autoSaveSavingToastId)) {
      toast({
        id: autoSaveSavingToastId,
        status: 'info',
        title: 'Salvando alterações...',
        description: 'Aguarde, o cadastro está sendo atualizado.',
        duration: 1200,
        isClosable: true,
        position: 'bottom-right'
      })
    }
  }

  const showAutoSaveSuccessToast = () => {
    const now = Date.now()

    // Evita muitos toasts de sucesso quando o usuário está digitando vários campos em sequência.
    if (now - lastAutoSaveSuccessToastAt.current < 4000) return

    lastAutoSaveSuccessToastAt.current = now

    toast({
      status: 'success',
      title: 'Alterações salvas',
      description: `Cadastro atualizado às ${format(new Date(), 'HH:mm')}.`,
      duration: 2200,
      isClosable: true,
      position: 'bottom-right'
    })
  }

  const showAutoSaveErrorToast = (message: string) => {
    const now = Date.now()
    const isSameRecentMessage =
      lastAutoSaveErrorMessage.current === message && now - lastAutoSaveErrorToastAt.current < 5000

    // Evita ficar disparando erro repetido a cada tecla enquanto o campo obrigatório ainda está inválido.
    if (isSameRecentMessage) return

    lastAutoSaveErrorMessage.current = message
    lastAutoSaveErrorToastAt.current = now

    toast({
      status: 'error',
      title: 'Não foi possível salvar',
      description: message,
      duration: 3500,
      isClosable: true,
      position: 'bottom-right'
    })
  }

  useEffect(() => {
    return () => {
      if (cadastroAutoSaveTimer.current) {
        clearTimeout(cadastroAutoSaveTimer.current)
      }

      if (mainPatchAutoSaveTimer.current) {
        clearTimeout(mainPatchAutoSaveTimer.current)
      }

      Object.values(relationAutoSaveTimers.current).forEach((timerValue) => {
        if (timerValue) {
          clearTimeout(timerValue)
        }
      })
    }
  }, [])

  const [sessions, setSessions] = useState<Sections[]>([])
  const [descriptionSession, setDescriptionSession] = useState('')
  const [idSession, setIdSession] = useState(0)
  const [isOpenCancel, setIsOpenCancel] = useState(false)

  // states attendance list components
  const statusOptionsDefault = [
    { value: 1, label: `${t('attendance.status.1')}` },
    { value: 2, label: `${t('attendance.status.2')}` },
    { value: 3, label: `${t('attendance.status.3')}` },
    { value: 4, label: `${t('attendance.status.4')}` },
    { value: 5, label: `${t('attendance.status.5')}` },
    { value: 6, label: `${t('attendance.status.6')}` },
    { value: 7, label: `${t('attendance.status.7')}` }
  ]
  const statusOptionsIndications = [
    { value: 1, label: `${t('indications.status.1')}` },
    { value: 2, label: `${t('indications.status.2')}` },
    { value: 3, label: `${t('indications.status.3')}` },
    { value: 4, label: `${t('indications.status.4')}` },
    { value: 5, label: `${t('indications.status.5')}` }
  ]
  const statusOptionsIndicationsEdit = [
    { value: 1, label: `${t('indications.status.1')}` },
    { value: 4, label: `${t('indications.status.4')}` },
    { value: 5, label: `${t('indications.status.5')}` }
  ]
  const [specialistIds, setSpecialistIds] = useState<String[]>([])
  const [statusParam, setStatusParam] = useState<String[]>([])
  const [attendance, setAttendance] = useState<AttendanceData>([])
  const [isLoadingAttendance, setIsLoadingAttendance] = useState(false)
  const [currentPageAttendance, setCurrentPageAttendance] = useState(1)
  const [totalOfRegisterAttendance, setTotalOfRegisterAttendance] = useState(0)
  // medical records filters
  // types options default
  const [medicalRecords, setMedicalRecords] = useState<MedicalRecordsData>([])
  const [arrayOpenTabs, setArrayOpenTabs] = useState<Array<number> | undefined>(undefined)
  const TypesMedicalData = [
    { value: 'forms', label: `${t('recording.types.1')}` },
    { value: 'prescriptions', label: `${t('recording.types.2')}` },
    { value: 'exams', label: `${t('recording.types.3')}` },
    { value: 'indications', label: `${t('recording.types.4')}` }
  ]
  const [medicalRecordsSpecialist, setMedicalRecordsSpecialist] = useState<string[]>([])
  const [medicalTypeDataFilter, setMedicalTypeDataFilter] = useState<string[]>([
    'forms',
    'prescriptions',
    'exams',
    'indications'
  ])
  const [isLoadingMedicalRecords, setIsLoadingMedicalRecords] = useState(false)
  const [medicalStartDate, setMedicalStartDate] = useState<string>('')
  const [medicalEndDate, setMedicalEndDate] = useState<string>('')
  const [medicalKeyword, setMedicalKeyword] = useState<string>('')
  // print templates list
  const [templates, setTemplates] = useState<Templates>([])
  // state services for indications add
  const [servicesIndications, setServicesIndications] = useState<ServicesData>([])

  // gallery state
  // view mode gallery photos and videos
  const [galleryCard, setGalleryCard] = useState<GalleryCardData>(null)
  const [galleryIsLoading, setGalleryIsLoading] = useState(false)
  const [galleryError, setGalleryError] = useState(false)

  // comparisons and gallery create
  const [newCardIsOpen, setNewCardIsOpen] = useState(false)
  const [typeCard, setTypeCard] = useState('')
  const [dateCard, setDateCard] = useState('')
  const [nameCard, setNameCard] = useState('')
  // states modal
  const [isOpen, setIsOpen] = useState(false)

  // states indications
  const [indicationsData, setIndicationsData] = useState<IndicationsDataInfo>([])
  const [totalOfRegisterIndication, setTotalOfRegisterIndication] = useState(0)
  const [isLoadingIndications, setIsLoadingIndications] = useState(false)
  const [currentPageIndication, setCurrentPageIndication] = useState(1)
  const [idIndication, setIdIndication] = useState<number | null>(null)
  const [idServiceIndication, setIdServiceIndication] = useState<number | null>(null)
  const [observationInd, setObservationInd] = useState<string | null>('')
  const [dateIndication, setDateIndication] = useState('')
  const [statusChangeIndication, setStatusChangeIndication] = useState(1)
  const [isOpenEditIndication, setIsOpenEditIndication] = useState(false)
  const [statusIndication, setStatusIndication] = useState<any>([])
  const [specialistsIndication, setSpecialistsIndication] = useState<any>([])
  const [listByIndication, setListByIndication] = useState('indication_date')
  const [orderByIndication, setOrderByIndication] = useState('')
  const [filtersIndication, setFiltersIndication] = useState<FiltersIndicationsData | null>({
    orderBy: 'indication_date',
    specialistIds: [],
    status: []
  })

  // states budgets
  const [budgetsData, setBudgetsData] = useState<BudgetsDataInfo>([])
  const [totalOfRegisterBudgets, setTotalOfRegisterBudgets] = useState(0)
  const [isLoadingBudgets, setIsLoadingBudgets] = useState(false)
  const [currentPageBudgets, setCurrentPageBudgets] = useState(1)
  const [specialistsBudgets, setSpecialistsBudgets] = useState<any>([])
  const [dateBudgets, setDateBudgets] = useState('')
  const [filtersBudgets, setFiltersBudgets] = useState<FiltersBudgetsData | null>({
    specialistIds: [],
    date: ''
  })

  const attendanceMqttTopics = React.useMemo(() => {
    if (!attendance?.length) return []

    const allArrayAllow = attendance.map((item) => {
      return `/attendances/${item?.hash}/allow-start-attendance/`
    })

    const allArrayFinish = attendance.map((item) => {
      return `/attendances/${item?.hash}/finish-attendance/`
    })

    const allArrayCancel = attendance.map((item) => {
      return `/attendances/${item?.hash}/cancel-attendance/`
    })

    return [...allArrayFinish, ...allArrayAllow, ...allArrayCancel]
  }, [attendance])

  const mqttTopics = React.useMemo(() => {
    const topics = [...attendanceMqttTopics]

    if (state?.hash) {
      topics.push(`/patient-updated/${state.hash}/`)
    }

    return topics
  }, [attendanceMqttTopics, state?.hash])

  // change allowNote true or false
  const handlerChangeAllowNote = async () => {
    if (!state?.id) return

    const nextAllowNote = !allowNotes

    try {
      scheduleMainPatch({ allow_note: nextAllowNote })
      setAllowNotes(nextAllowNote)
    } catch (error: unknown) {
      console.log(error)
    }
  }

  // websocket mqtt listen
  const { message: clientMessage } = useSubscription(mqttTopics)
  // function getInfo for view client
  const GetClient = async () => {
    const { getClientById } = clientService

    const data: ClientData = await getClientById(params.id)

    setState(data ?? null)
    return data ?? null
  }

  const getPatientRelations = async () => {
    const [
      emailsResponse,
      healthInsuranceResponse,
      parentsResponse,
      telephonesResponse,
      telephonesWhatsappResponse,
      addressesResponse
    ] = await Promise.all([
      apiAuth.get(`clinics/patients/${params.id}/emails/`),
      apiAuth.get(`clinics/patients/${params.id}/health-insurances/`),
      apiAuth.get(`clinics/patients/${params.id}/parents/`),
      apiAuth.get(`clinics/patients/${params.id}/telephones/`),
      apiAuth.get(`clinics/patients/${params.id}/telephones-whatsapp/`),
      apiAuth.get(`clinics/patients/${params.id}/addresses/`)
    ])

    const nextEmails = emailsResponse?.data?.length
      ? emailsResponse.data
      : [
          {
            id: lodash.uniqueId(),
            email: '',
            description: ''
          }
        ]

    setEmails(nextEmails)

    const nextHealthInsurance = healthInsuranceResponse?.data?.length
      ? healthInsuranceResponse.data.map((heal: any) => {
          return {
            healthInsurance: {
              value: heal.health_insurance.id,
              label: heal.health_insurance.name
            },
            healthInsuranceNumber: heal?.number || ''
          }
        })
      : [
          {
            healthInsurance: null,
            healthInsuranceNumber: ''
          }
        ]

    setHealthInsurance(nextHealthInsurance)

    const nextParents = parentsResponse?.data?.length
      ? parentsResponse.data.map((item: any) => {
          return {
            patientRelatives: {
              value: item?.parent?.id,
              label: item?.parent?.name
            },
            patientDegree: item?.parent_degree
          }
        })
      : [
          {
            patientRelatives: null,
            patientDegree: ''
          }
        ]

    setPatientRelatives(nextParents)

    const nextTelephones = telephonesResponse?.data?.length
      ? telephonesResponse.data.map((number: any) => {
          return {
            contact: remaskCaractersAll(number?.number) || '',
            ddi_country: number?.ddi_country || '',
            id: number?.id || lodash.uniqueId(),
            description: number?.description || ''
          }
        })
      : [
          {
            contact: '',
            ddi_country: decodeToken?.clinic?.clinic_contacts[0]?.ddi_country || '+55',
            id: lodash.uniqueId(),
            description: ''
          }
        ]

    setNumbers(nextTelephones)

    const nextTelephonesWhatsapp = telephonesWhatsappResponse?.data?.length
      ? telephonesWhatsappResponse.data.map((number: any) => {
          return {
            contact: remaskCaractersAll(number?.number) || '',
            ddi_country: number?.ddi_country || '',
            id: number?.id || lodash.uniqueId(),
            description: number?.description || ''
          }
        })
      : [
          {
            contact: '',
            ddi_country: decodeToken?.clinic?.clinic_contacts[0]?.ddi_country || '+55',
            id: lodash.uniqueId(),
            description: ''
          }
        ]

    setNumbersWhats(nextTelephonesWhatsapp)

    const quantity = addressesResponse?.data?.length || 0
    const getAddress = addressesResponse?.data?.[quantity - 1] || {}

    setNumberAddress(getAddress?.number || '')
    setComplement(getAddress?.complement || '')
    setCepAddress(getAddress?.zip_code || '')
    setStateAddress(getAddress?.state || '')

    address.setCep(getAddress?.zip_code || '')
    address.setAddress(getAddress?.street || '')
    address.setBairro(getAddress?.district || '')
    address.setMunicipio(getAddress?.city || '')

    address.optionsContries.map((contry: any) => {
      if (getAddress?.country === contry.label) {
        address.setSeletedCountry(contry || '')
      }
    })

    StateOptions.map((ufAux: any) => {
      if (getAddress?.state === ufAux?.label || getAddress?.state === ufAux?.sigla) {
        address.setSelectedState(ufAux || '')
        address.setUfDefault(ufAux || '')
      }
    })
  }

  // tabIndex control get cards Gallery Info
  const getCardsTimeline = async () => {
    setGalleryIsLoading(true)

    const { data } = await apiAuth.get(`clinics/gallery-cards/`, {
      params: {
        patient_id: params.id
      }
    })

    if (data.results !== undefined) {
      setGalleryCard(data.results)
    } else {
      setGalleryCard(null)
      setGalleryError(true)
    }

    setGalleryIsLoading(false)
  }

  // client sessions

  useEffect(() => {
    apiAuth
      .get<Sections[]>(`clinics/patients/${params?.id}/service-sessions/`, {
        params: {
          status: '1',
          min_session: '1'
        }
      })
      .then(({ data }) => {
        setSessions(data)
      })

    return () => {}
  }, [])

  // get documents options
  useEffect(() => {
    apiAuth.get<ClinicData>(`clinics/clinics/${clinicId}/`).then(({ data }) => {
      setClinicData(data)
      if (data?.patient_email) {
        setEmailIsRequired(data?.patient_email)
      }
      if (data?.documents) {
        const documentsFormat = data?.documents?.map((doc) => {
          if (clinic_language === 'en') {
            return {
              label: doc?.name_en,
              value: doc?.id,
              regex: doc?.regex
            }
          }

          if (clinic_language === 'es') {
            return {
              label: doc?.name_en,
              value: doc?.id,
              regex: doc?.regex
            }
          }

          return {
            label: doc?.name_ptbr,
            value: doc?.id,
            regex: doc?.regex
          }
        })

        setDocuments(documentsFormat)
      }
    })

    return () => {}
  }, [])

  // create new Card function
  const handlerCreateNewCard = async () => {
    if (nameCard === '') {
      toast({
        duration: 3000,
        title: t('gallery.cardCreate.error.title'),
        position: 'top',
        status: 'error',
        description: t('gallery.cardCreate.error.message')
      })

      return
    }

    const payload = {
      gallery_patient: params.id,
      name: nameCard,
      date: dateCard
    }

    if (typeCard === 'gallery') {
      try {
        const { data } = await apiAuth.post(`clinics/gallery-cards/`, payload)

        if (data.id !== undefined) {
          toast({
            duration: 3000,
            title: t('gallery.cardCreate.success.title'),
            position: 'top',
            status: 'success',
            description: t('gallery.cardCreate.success.message')
          })
          setDateCard(
            format(new Date(), 'yyyy-MM-dd', {
              locale: LocaleApp
            })
          )
          getCardsTimeline()
          setNameCard(
            format(new Date(), 'dd/MM/yyyy', {
              locale: LocaleApp
            })
          )
          setNewCardIsOpen(false)
        }
      } catch (error: any) {
        toast({
          duration: 3000,
          title: t('Error!'),
          position: 'top',
          status: 'error',
          description: `${error.response?.data?.message}`
        })
      }
    }

    if (typeCard === 'comparisons') {
      try {
        const { data } = await apiAuth.post(`clinics/comparisons/`, payload)

        if (data.id !== undefined) {
          toast({
            duration: 3000,
            title: t('gallery.cardCreate.success.title'),
            position: 'top',
            status: 'success',
            description: t('gallery.cardCreate.success.message')
          })
          setDateCard(
            format(new Date(), 'yyyy-MM-dd', {
              locale: LocaleApp
            })
          )
          setNameCard(
            format(new Date(), 'dd/MM/yyyy', {
              locale: LocaleApp
            })
          )
          getCardsTimeline()
          setNewCardIsOpen(false)
        }
      } catch (error: any) {
        toast({
          duration: 3000,
          title: t('Error!'),
          position: 'top',
          status: 'error',
          description: `${error.response?.data?.message}`
        })
      }
    }

    setNameCard(
      format(new Date(), 'dd/MM/yyyy', {
        locale: LocaleApp
      })
    )
  }

  // verify title is view
  const verifyTitleIsView = (record: MedicalRecords) => {
    let isView = false

    if (record?.services_not_performed?.length > 0) {
      isView = true
    }

    if (record?.sessions_not_performed?.length > 0) {
      isView = true
    }

    return isView
  }

  // cancel session by id
  const handlerCancelSessionById = async (id: number) => {
    const payload = {
      description: descriptionSession || null
    }

    try {
      const { data } = await apiAuth.put(`clinics/attendance-sessions/${id}/cancel/`, payload)

      if (data) {
        toast({
          duration: 3000,
          title: 'Sessão cancelada',
          position: 'top',
          status: 'success'
        })

        apiAuth
          .get<Sections[]>(`clinics/patients/${params?.id}/service-sessions/`, {
            params: {
              status: '1',
              min_session: '1'
            }
          })
          .then(({ data: session }) => {
            setSessions(session)
          })
      }
    } catch (error: any) {
      toast({
        duration: 3000,
        title: t('Error!'),
        position: 'top',
        status: 'error',
        description: `${error.response?.data?.message}`
      })
    } finally {
      setIsOpenCancel(false)
    }
  }

  // attendances return infos ticket
  // jxs status item ticket
  const returnJsxElementStatusTicket = (statusPayment: number | null | undefined) => {
    if (statusPayment === 1) {
      return (
        <Tooltip
          label={t('attendance.statusTicket.1')}
          aria-label={t('attendance.statusTicket.1')}
          hasArrow
          placement="top-start"
        >
          <Box ml="1rem" w="24px">
            <FiDollarSign color="#c71717f4" size={16} style={{ cursor: 'default' }} />
          </Box>
        </Tooltip>
      )
    }

    if (statusPayment === 2) {
      return (
        <Tooltip
          label={t('attendance.statusTicket.2')}
          aria-label={t('attendance.statusTicket.2')}
          hasArrow
          placement="top-start"
        >
          <Box ml="1rem" w="24px">
            <FiDollarSign color="#56c20ff4" size={16} style={{ cursor: 'default' }} />
          </Box>
        </Tooltip>
      )
    }

    if (statusPayment === 3) {
      return (
        <Tooltip
          label={t('attendance.statusTicket.3')}
          aria-label={t('attendance.statusTicket.3')}
          hasArrow
          placement="top-start"
        >
          <Box ml="1rem" w="24px">
            <FiDollarSign color="#fd7011f0" size={16} style={{ cursor: 'default' }} />
          </Box>
        </Tooltip>
      )
    }

    if (statusPayment === 4) {
      return (
        <Tooltip
          label={t('attendance.statusTicket.4')}
          aria-label={t('attendance.statusTicket.4')}
          hasArrow
          placement="top-start"
        >
          <Box ml="1rem" w="24px">
            <FiDollarSign color="#192facdc" size={16} style={{ cursor: 'default' }} />
          </Box>
        </Tooltip>
      )
    }

    return (
      <Tooltip
        label={t('attendance.statusTicket.null')}
        aria-label={t('attendance.statusTicket.null')}
        hasArrow
        placement="top-start"
      >
        <Box ml="1rem" w="24px">
          <FiDollarSign color="#9699B0" size={16} style={{ cursor: 'default' }} />
        </Box>
      </Tooltip>
    )
  }

  const verifyStatusAttendanceButton = (statusAtt: number) => {
    let verify = false

    if (statusAtt === 3) {
      return verify
    }

    if (statusAtt === 4) {
      return verify
    }

    if (statusAtt === 6) {
      return verify
    }

    if (statusAtt === 7) {
      return verify
    }

    verify = true
    return verify
  }

  // websocket receive message
  useEffect(() => {
    if (!clientMessage?.topic) return

    const topic = clientMessage.topic.split('/')
    const action = topic?.[1]

    if (action === 'patient-updated') {
      const handlePatientUpdated = async () => {
        try {
          isApplyingPatientMqttRef.current = true

          const rawMessage =
            typeof clientMessage.message === 'string'
              ? clientMessage.message
              : clientMessage.message?.toString()

          const payload = JSON.parse(rawMessage || '{}')

          console.log('[MQTT][patient-updated] tópico recebido', {
            topic: clientMessage.topic,
            patientId: payload?.patient_id,
            hash: payload?.hash,
            updatedAt: payload?.patient?.updated_at,
            payload
          })

          if (String(payload?.patient_id) !== String(params.id)) {
            console.log('[MQTT][patient-updated] ignorado: paciente diferente', {
              currentPatientId: params.id,
              receivedPatientId: payload?.patient_id
            })

            return
          }

          if (isCadastroFieldFocusedRef.current) {
            pendingPatientRealtimeRefreshRef.current = true
            console.log(
              '[MQTT][patient-updated] atualização pausada porque usuário está com foco no cadastro',
              {
                topic: clientMessage.topic,
                patientId: payload?.patient_id
              }
            )
            return
          }

          if (payload?.patient) {
            const patient = payload.patient

            if (isProbablyOwnMainPatchEcho(patient)) {
              console.log(
                '[MQTT][patient-updated] eco do próprio patch detectado; aplicando sem disparar autosave',
                {
                  patientId: patient?.id,
                  lastLocalPatch: lastLocalMainPatchRef.current?.payload
                }
              )
            }

            console.log('[MQTT][patient-updated] aplicando campos do paciente', {
              patientId: patient?.id,
              fields: Object.keys(patient || {}),
              documents: patient?.documents,
              documentNumber: patient?.document_number,
              allowNote: patient?.allow_note,
              image: patient?.image
            })

            setState((previousClient) => {
              const nextClient = previousClient
                ? {
                    ...previousClient
                  }
                : {
                    ...patient
                  }

              if (patient.id !== undefined) {
                nextClient.id = String(patient.id)
              }

              if (patient.hash !== undefined) {
                nextClient.hash = patient.hash
              }

              if (patient.name !== undefined) {
                nextClient.name = patient.name || ''
              }

              if (patient.social_name !== undefined) {
                nextClient.social_name = patient.social_name || ''
              }

              if (patient.birth_date !== undefined) {
                nextClient.birth_date = patient.birth_date || ''
              }

              if (patient.sex !== undefined) {
                nextClient.sex = patient.sex
              }

              if (patient.document !== undefined) {
                nextClient.document = patient.document
              }

              if (patient.document_number !== undefined) {
                nextClient.document_number = patient.document_number || ''
              }

              if (patient.documents !== undefined) {
                nextClient.documents = Array.isArray(patient.documents) ? patient.documents : []
              }

              if (patient.observation !== undefined) {
                nextClient.observation = patient.observation || ''
              }

              if (patient.alerts !== undefined) {
                nextClient.alerts = patient.alerts || ''
              }

              if (patient.ocuppation !== undefined) {
                nextClient.ocuppation = patient.ocuppation || ''
              }

              if (patient.is_active !== undefined) {
                nextClient.is_active = Boolean(patient.is_active)
              }

              if (patient.allow_whatsapp !== undefined) {
                nextClient.allow_whatsapp = Boolean(patient.allow_whatsapp)
              }

              if (patient.allow_note !== undefined) {
                nextClient.allow_note = Boolean(patient.allow_note)
              }

              if (patient.image !== undefined) {
                nextClient.image = patient.image || ''
              }

              if (patient.patient_tags !== undefined) {
                const tagIds = Array.isArray(patient.patient_tags) ? patient.patient_tags : []

                const nextKey = JSON.stringify(tagIds.map((id: any) => Number(id)).sort())
                lastAppliedTagsKeyRef.current = nextKey

                const nextTags = buildSelectedTagsFromIds(tagIds)

                console.log('[TAGS][mqtt]', {
                  tagIds,
                  nextTags
                })

                setPatientsTags(nextTags as any)
              }

              if (patient.origins !== undefined) {
                nextClient.origins = Array.isArray(patient.origins) ? patient.origins : []
              }

              if (patient.address !== undefined) {
                nextClient.address = patient.address
              }

              return nextClient
            })

            if (patient.name !== undefined) {
              setName(patient.name || '')
            }

            if (patient.social_name !== undefined) {
              setSocialName(patient.social_name || '')
              setPatientName(patient.social_name || '')
            }

            if (patient.birth_date !== undefined) {
              setBirthDate(patient.birth_date || '')

              if (patient.birth_date) {
                const formatDate = format(new Date(patient.birth_date), 'dd/MM/yyyy', {
                  locale: LocaleApp
                })

                const age = calculateAge(formatDate)
                setAgeUser(String(age))
              } else {
                setAgeUser('')
              }
            }

            if (patient.sex !== undefined) {
              setSex(patient.sex ? String(patient.sex) : '')
            }

            if (patient.document !== undefined) {
              if (patient.document) {
                if (decodeToken?.clinic_language === 'pt') {
                  setValueDocumentSelect({
                    label: patient.document?.name_ptbr,
                    regex: patient.document?.regex,
                    value: patient.document?.id
                  })
                } else {
                  setValueDocumentSelect({
                    label: patient.document?.name_en,
                    regex: patient.document?.regex,
                    value: patient.document?.id
                  })
                }
              } else {
                setValueDocumentSelect(null)
              }
            }

            if (patient.document_number !== undefined) {
              setNumberDocument(patient.document_number || '')
            }

            if (patient.documents !== undefined) {
              const incomingDocuments = Array.isArray(patient.documents) ? patient.documents : []

              const layoutDocument = clinicData?.documents_preferences?.map((doc) => {
                const incomingDocument = incomingDocuments.find(
                  (docClient: DocumentClient) => docClient.id === doc.id
                )

                return {
                  acronym: incomingDocument?.acronym || doc.document?.acronym,
                  id: doc?.id,
                  index: incomingDocument?.index || doc?.document?.index,
                  is_required:
                    incomingDocument?.is_required !== undefined
                      ? incomingDocument.is_required
                      : doc?.is_required,
                  is_view:
                    incomingDocument?.is_view !== undefined
                      ? incomingDocument.is_view
                      : doc?.is_view,
                  name_en: incomingDocument?.name_en || doc?.document?.name_en,
                  name_es: incomingDocument?.name_es || doc?.document?.name_es,
                  name_ptbr: incomingDocument?.name_ptbr || doc?.document?.name_ptbr,
                  regex: incomingDocument?.regex || doc?.document?.regex,
                  value: incomingDocument?.value || '',
                  valueMask: incomingDocument?.valueMask || ''
                }
              })

              setDocumentsClient(layoutDocument || incomingDocuments)

              console.log('[MQTT][patient-updated] documentos aplicados', {
                incomingDocuments,
                layoutDocument
              })
            }

            if (patient.observation !== undefined) {
              setObservationClient(patient.observation || '')
            }

            if (patient.alerts !== undefined) {
              setAlertsClient(patient.alerts || '')
            }

            if (patient.ocuppation !== undefined) {
              setOccupation(patient.ocuppation || '')
            }

            if (patient.is_active !== undefined) {
              setIsActive(Boolean(patient.is_active))
            }

            if (patient.allow_whatsapp !== undefined) {
              setIsAccept(Boolean(patient.allow_whatsapp))
            }

            if (patient.allow_note !== undefined) {
              setAllowNotes(Boolean(patient.allow_note))
            }

            if (patient.image !== undefined) {
              setImgSrc(patient.image || '')
            }
          }

          console.log('[MQTT][patient-updated] buscando dados relacionados', {
            patientId: params.id
          })

          await getPatientRelations()

          console.log('[MQTT][patient-updated] atualização finalizada', {
            patientId: params.id
          })
        } catch (error) {
          console.log('[MQTT][patient-updated] erro ao processar mensagem', error)
        } finally {
          setTimeout(() => {
            isApplyingPatientMqttRef.current = false
          }, 500)
        }
      }

      handlePatientUpdated()

      return
    }

    const hash = topic?.[2]

    switch (action as ActionsWs) {
      case 'allow-start-attendance': {
        const newAttendanceValue = attendance.map((att) => {
          return att.hash === hash
            ? {
                ...att,
                allowed_start_attendance: true
              }
            : att
        })

        setAttendance(newAttendanceValue)
        break
      }

      case 'cancel-attendance': {
        const newAttendance = attendance.map((att) => {
          return att.hash === hash
            ? {
                ...att,
                allowed_start_attendance: false,
                status: 3,
                status_by_system: true
              }
            : att
        })

        setAttendance(newAttendance)
        break
      }

      case 'finish-attendance': {
        const newAttFinish = attendance.map((att) => {
          return att.hash === hash
            ? {
                ...att,
                allowed_start_attendance: false,
                status: 7,
                status_by_system: true
              }
            : att
        })

        setAttendance(newAttFinish)
        break
      }

      default:
        break
    }
  }, [clientMessage])

  // get infos and set today inputs
  useEffect(() => {
    GetClient()
    setDateCard(today)
  }, [])

  // get templates for print
  // buscar no component pai para evitar várias chamadas pra pegar esse valor
  useEffect(() => {
    const getDataTemplates = async () => {
      const { data } = await apiAuth.get<Templates>(`clinics/prescription-email-templates/`, {
        params: {
          noPaginate: 1,
          is_active: true
        }
      })

      setTemplates(data)
    }

    getDataTemplates()

    return () => {}
  }, [])

  function defineNameDocumentByLanguage(document: DocumentClient) {
    if (decodeToken?.clinic_language === 'en') {
      return document?.name_ptbr
    }

    if (decodeToken?.clinic_language === 'es') {
      return document?.name_es
    }

    return document?.name_ptbr
  }

  useEffect(() => {
    if (!state?.id) return
    if (!clinicData) return

    if (isApplyingPatientMqttRef.current) {
      return
    }

    setIsCadastroHydrated(false)

    if (state.name !== undefined) {
      setName(state.name || '')
    }

    if (state.social_name !== undefined) {
      setSocialName(state.social_name || '')
      setPatientName(state.social_name || '')
    }

    if (state.allow_note !== undefined) {
      setAllowNotes(Boolean(state.allow_note))
    }

    if (state.is_active !== undefined) {
      setIsActive(Boolean(state.is_active))
    }

    if (state.allow_whatsapp !== undefined) {
      setIsAccept(Boolean(state.allow_whatsapp))
    }

    if (state.image !== undefined && !isImageInitializedRef.current) {
      setImgSrc(state.image || '')
      isImageInitializedRef.current = true
    }

    if (state.birth_date !== undefined) {
      if (state.birth_date) {
        setBirthDate(state.birth_date)

        const formatDate = format(new Date(state.birth_date), 'dd/MM/yyyy', {
          locale: LocaleApp
        })

        const age = calculateAge(formatDate)
        setAgeUser(String(age))
      } else {
        setBirthDate('')
        setAgeUser('')
      }
    }

    if (state.sex !== undefined) {
      setSex(state.sex ? String(state.sex) : '')
    }

    if (state.document !== undefined) {
      if (state.document) {
        setValueDocumentSelect({
          label:
            decodeToken?.clinic_language === 'pt'
              ? state.document.name_ptbr
              : state.document.name_en,
          regex: state.document.regex,
          value: state.document.id
        })
      } else {
        setValueDocumentSelect(null)
      }
    }

    if (state.document_number !== undefined) {
      setNumberDocument(state.document_number || '')
    }

    if (state.documents !== undefined) {
      const patientDocuments = Array.isArray(state.documents) ? state.documents : []

      const layoutDocument = clinicData.documents_preferences?.map((doc) => {
        const getDocument = patientDocuments.find(
          (docClient) => Number(docClient.id) === Number(doc.id)
        )

        return {
          acronym: getDocument?.acronym || doc.document?.acronym,
          id: doc?.id,
          index: getDocument?.index || doc?.document?.index,
          is_required:
            getDocument?.is_required !== undefined ? getDocument.is_required : doc?.is_required,
          is_view: getDocument?.is_view !== undefined ? getDocument.is_view : doc?.is_view,
          name_en: getDocument?.name_en || doc?.document?.name_en,
          name_es: getDocument?.name_es || doc?.document?.name_es,
          name_ptbr: getDocument?.name_ptbr || doc?.document?.name_ptbr,
          regex: getDocument?.regex || doc?.document?.regex,
          value: getDocument?.value || '',
          valueMask: getDocument?.valueMask || ''
        }
      })

      setDocumentsClient(layoutDocument || patientDocuments)
    } else if (clinicData.documents_preferences?.length) {
      const layoutDocument = clinicData.documents_preferences.map((doc) => {
        return {
          acronym: doc.document?.acronym,
          id: doc?.id,
          index: doc?.document?.index,
          is_required: doc?.is_required,
          is_view: doc?.is_view,
          name_en: doc?.document?.name_en,
          name_es: doc?.document?.name_es,
          name_ptbr: doc?.document?.name_ptbr,
          regex: doc?.document?.regex,
          value: '',
          valueMask: ''
        }
      })

      setDocumentsClient(layoutDocument)
    }

    if (state.observation !== undefined) {
      setObservationClient(state.observation || '')
    }

    if (state.alerts !== undefined) {
      setAlertsClient(state.alerts || '')
    }

    if (state.ocuppation !== undefined) {
      setOccupation(state.ocuppation || '')
    }

    const hydratedTimer = setTimeout(() => {
      setIsCadastroHydrated(true)
      setMessageChangeForSave(false)
      setAutoSaveError(null)
    }, 600)

    return () => clearTimeout(hydratedTimer)
  }, [state?.id, clinicData])

  useEffect(() => {
    getPatientRelations()
  }, [params.id])

  useEffect(() => {
    if (!state?.id) return
    if (!tagsUpdate?.length) return
    if (isApplyingPatientMqttRef.current) return

    const tagIds = Array.isArray(state.patient_tags) ? state.patient_tags : []
    const nextKey = JSON.stringify(tagIds.map((id) => Number(id)).sort())

    if (nextKey === lastAppliedTagsKeyRef.current) return

    lastAppliedTagsKeyRef.current = nextKey

    const nextTags = buildSelectedTagsFromIds(tagIds)

    console.log('[TAGS][hydrate]', {
      tagIds,
      nextTags
    })

    setPatientsTags(nextTags as any)
  }, [state?.id, tagsUpdate])

  // get values services by indications
  useEffect(() => {
    apiAuth
      .get<GetResponseDefaultData>(`clinics/${clinicId}/services/`, {
        params: {
          is_active: true,
          noPaginate: 1
        }
      })
      .then((response) => {
        const formattedServices = response.data.map((service) => {
          return {
            value: service.id,
            label: service.name
          }
        })

        setServicesIndications(formattedServices)
      })

    return () => {}
  }, [clinicId])

  // Get values for update
  useEffect(() => {
    if (state === null) {
      return
    }

    if (state?.origins !== undefined) {
      if (state?.origins.length > 0) {
        const originsDefault = state.origins
        const originsValues = originsUpdate
        const originsSelect = originsDefault.map((item) =>
          originsValues.find((tag) => tag.id === item)
        )

        if (originsSelect[0] !== undefined) {
          setPatientsOrigins(
            originsSelect.map((tag: any) => {
              return {
                value: String(tag.id),
                label: String(tag.name)
              }
            })
          )
        }
      }
    }
  }, [originsUpdate, state])

  // Open modal new Card
  function handleCreateNewCardOpenModal() {
    setNewCardIsOpen(true)
  }

  // Close modal new Card
  function handleCreateNewCardCloseModal() {
    setNewCardIsOpen(false)
  }

  // format tags, origens
  function formatTagsServices() {
    if (patientsTags.length > 0) {
      const serviceTags = patientsTags.map((tag: any) => {
        return Number(tag.value)
      })

      return serviceTags
    }

    return []
  }

  function formatOriginsServices() {
    if (patientsOrigins.length > 0) {
      const serviceOrigins = patientsOrigins.map((origin: any) => {
        return Number(origin.value)
      })

      return serviceOrigins
    }

    return []
  }

  function formatNumbers() {
    if (numbers[0].contact === '') {
      return undefined
    }

    const telephones = numbers.map((item, index) => {
      return {
        ddi_country: item?.ddi_country === '' ? null : item?.ddi_country,
        number: item?.contact === '' ? null : item?.contact,
        index,
        description: item?.description === '' ? null : item?.description
      }
    })

    return telephones
  }

  function formatNumbersWhats() {
    if (numbersWhats[0].contact === '') {
      return undefined
    }

    const telephones = numbersWhats.map((item, index) => {
      return {
        ddi_country: item?.ddi_country === '' ? null : item?.ddi_country,
        number: item?.contact === '' ? null : item?.contact,
        index,
        description: item?.description === '' ? null : item?.description
      }
    })

    return telephones
  }

  function formatEmails() {
    if (emails[0].email === '') {
      return undefined
    }

    const emailsFormat = emails.map((email, index) => {
      return {
        email: email.email === '' ? null : email.email,
        index,
        description: email.description === '' ? null : email.description
      }
    })

    return emailsFormat
  }

  function formatHealthInsurance() {
    const healthInsuranceAllSelectReturn = healthInsurance.map((heal) => {
      if (heal.healthInsurance !== null) {
        return {
          health_insurance: {
            id: heal.healthInsurance?.value
          },
          number: heal.healthInsuranceNumber !== '' ? heal.healthInsuranceNumber : null
        }
      }

      return false
    })

    const health = healthInsuranceAllSelectReturn.filter(Boolean)

    return health
  }

  function formatPatientRelatives() {
    const patientRelativesAllSelectReturn = patientRelatives.map((patient) => {
      if (patient.patientRelatives !== null) {
        return {
          parent: {
            id: patient.patientRelatives.value
          },
          parent_degree: Number(patient.patientDegree || '5')
        }
      }

      return false
    })

    const parent = patientRelativesAllSelectReturn.filter(Boolean)

    return parent
  }

  // is required
  function isRequiredReturnForForm(obj: any | null | string) {
    let isRequired = false

    if (obj !== null) {
      isRequired = true
      return isRequired
    }

    if (obj === '') {
      isRequired = true
      return isRequired
    }

    return isRequired
  }

  // // NUMBERS FUNCTIONS
  // function handleAddNumbers() {
  //   setNumbers([
  //     ...numbers,
  //     {
  //       contact: '',
  //       ddi_country: '+55',
  //       id: '',
  //       description: ''
  //     }
  //   ])
  // }

  // function handleRemoveNumbers(index: number) {
  //   const values = [...numbers]
  //   values.splice(index, 1)
  //   setNumbers(values)
  // }

  function handleChangeInputNumbers(index: number, e: React.ChangeEvent<HTMLInputElement>) {
    const values = [...numbers]
    markRelationAsChanged('telephones')

    if (values[index].ddi_country === '+55') {
      values[index].contact = mask(e.target.value, '(99) 99999-9999')
    } else {
      values[index].contact = mask(e.target.value, '9999999999999999')
    }

    setNumbers(values)
  }

  function handlerChangeDescriptionContact(
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    const allNumbers = [...numbers]
    markRelationAsChanged('telephones')

    allNumbers[index].description = event.target.value

    setNumbers(allNumbers)
  }

  function handleChangeInputNumbersWhats(index: number, e: React.ChangeEvent<HTMLInputElement>) {
    const values = [...numbersWhats]
    markRelationAsChanged('telephonesWhatsapp')

    if (values[index].ddi_country === '+55') {
      values[index].contact = mask(e.target.value, '(99) 99999-9999')
    } else {
      values[index].contact = mask(e.target.value, '9999999999999999')
    }

    setNumbersWhats(values)
  }

  function handlerChangeDescriptionContactWhats(
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    const allNumbers = [...numbersWhats]
    markRelationAsChanged('telephonesWhatsapp')

    allNumbers[index].description = event.target.value

    setNumbersWhats(allNumbers)
  }

  // EMAILS FUNCTIONS
  function handlerChangeEmail(index: number, event: React.ChangeEvent<HTMLInputElement>) {
    const allEmails = [...emails]
    markRelationAsChanged('emails')

    allEmails[index].email = event.target.value

    setEmails(allEmails)
  }

  function handlerChangeEmailDescription(
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    const allEmails = [...emails]
    markRelationAsChanged('emails')

    allEmails[index].description = event.target.value

    setEmails(allEmails)
  }

  function handleGetMethod() {
    const local = history.location.pathname

    if (local.indexOf('create') !== -1) {
      setLocal('create')
    } else {
      setLocal('update')
    }
  }

  // cal age
  function handleDefinedAge(e: React.ChangeEvent<HTMLInputElement>) {
    markCadastroAsChanged()
    if (e.target.value.length === 10) {
      const age = calculateAge(
        format(new Date(e.target.value), 'dd/MM/yyyy', { locale: LocaleApp })
      )
      setAgeUser(String(age))
    } else if (e.target.value.length < 10) {
      setAgeUser('')
    }
  }

  const handleCloseModal = async () => {
    if (
      typeof imgFile === 'string' &&
      imgFile &&
      imgFile !== lastSavedImageRef.current &&
      state?.id
    ) {
      await handleUploadPatientImage(imgFile)
    }

    setIsOpen(false)
  }

  const normalizeRequiredString = (value?: string | null) => {
    return value?.trim() || ''
  }

  const normalizeOptionalString = (value?: string | null) => {
    const normalized = value?.trim()
    return normalized ? normalized : null
  }

  const normalizeSelectedOptions = (event: any) => {
    if (!event) return []
    if (Array.isArray(event)) return event
    return [event]
  }

  const buildSelectedTagsFromIds = (tagIds?: Array<number | string>) => {
    const ids = Array.isArray(tagIds) ? tagIds : []

    return ids
      .map((id) => {
        const tag = tagsUpdate.find((item) => Number(item.id) === Number(id))

        if (!tag) return null

        return {
          value: Number(tag.id),
          label: String(tag.name)
        }
      })
      .filter(Boolean)
  }

  const removeUndefinedFields = <T extends Record<string, any>>(payload: T) => {
    return Object.fromEntries(
      Object.entries(payload).filter(([, value]) => value !== undefined)
    ) as Partial<T>
  }

  const buildPayloadKey = (payload: Record<string, any>) => {
    return JSON.stringify(payload)
  }

  const normalizeDocumentsForPayload = (documentsToNormalize: DocumentClient[]) => {
    return documentsToNormalize.map((document) => ({
      ...document,
      value: normalizeOptionalString(document?.value) || '',
      valueMask: normalizeOptionalString(document?.valueMask) || ''
    }))
  }

  const isProbablyOwnMainPatchEcho = (patient: any) => {
    const lastLocalPatch = lastLocalMainPatchRef.current

    if (!lastLocalPatch) return false
    if (Date.now() - lastLocalPatch.at > 3000) return false

    return Object.entries(lastLocalPatch.payload).every(([key, value]) => {
      return JSON.stringify(patient?.[key]) === JSON.stringify(value)
    })
  }

  const clearCadastroAutoSaveTimer = () => {
    if (cadastroAutoSaveTimer.current) {
      clearTimeout(cadastroAutoSaveTimer.current)
      cadastroAutoSaveTimer.current = null
    }
  }

  const buildCadastroPayload = (
    values: Partial<FormData> = {},
    options: { includeImage?: boolean } = {}
  ) => {
    const { includeImage = true } = options
    const payloadTelephones = formatNumbers()
    const payloadTelephonesWhats = formatNumbersWhats()
    const payloadEmails = formatEmails()
    const payloadParent = formatPatientRelatives()
    const payloadHeal = formatHealthInsurance()

    const payloadAddress = [
      removeUndefinedFields({
        zip_code: normalizeOptionalString(address.cep || state?.address?.zip_code || null),
        street: normalizeOptionalString(address.address || state?.address?.street || null),
        number: normalizeOptionalString(numberAddress || state?.address?.number || null),
        district: normalizeOptionalString(address.bairro || state?.address?.district || null),
        city: normalizeOptionalString(address.municipio || state?.address?.city || null),
        state: normalizeOptionalString(
          address.ufDefault.label ||
            address?.seletedState.label ||
            values.state ||
            stateAddress ||
            null
        ),
        country: normalizeOptionalString(
          address.seletedCountry.label || state?.address?.country || null
        ),
        complement: normalizeOptionalString(complement || state?.address?.observation || null),
        index: 0
      })
    ]

    const patient_tags = formatTagsServices()
    const origins = formatOriginsServices()
    const isRemoteImage =
      imgSrc.startsWith('http://') || imgSrc.startsWith('https://') || imgSrc.startsWith('/media/')

    const normalizedDocumentsClient = normalizeDocumentsForPayload(documentsClient)

    const basePayload = {
      name: normalizeRequiredString(name),
      social_name: normalizeRequiredString(socialName),
      birth_date: birth_date || null,
      document_number: normalizeOptionalString(numberDocument),
      document: valueDocumentSelect !== null ? { id: valueDocumentSelect?.value } : null,
      sex: Number(sex) || undefined,
      observation: normalizeOptionalString(observationClient),
      is_active,
      allow_whatsapp: is_accept,
      alerts: normalizeOptionalString(alertsClient),
      ocuppation: normalizeOptionalString(occupation),
      patient_tags,
      origins,
      documents: normalizedDocumentsClient
    }

    const imagePayload = includeImage
      ? {
          image: imgSrc === '' ? '' : isRemoteImage ? undefined : imgFile
        }
      : {}

    const payload = removeUndefinedFields({
      ...basePayload,
      ...imagePayload
    })

    return {
      payload,
      payloadTelephones,
      payloadTelephonesWhats,
      payloadEmails,
      payloadParent,
      payloadHeal,
      payloadAddress,
      origins
    }
  }

  const validateCadastroRequiredFields = (origins: Array<any>) => {
    const normalizedName = normalizeRequiredString(name)
    const normalizedSocialName = normalizeRequiredString(socialName)
    const normalizedDocumentNumber = normalizeRequiredString(numberDocument)

    if (!normalizedName) {
      return 'Nome do paciente é obrigatório.'
    }

    if (is_active && !normalizedSocialName) {
      return 'Nome social do paciente é obrigatório.'
    }

    if (is_active && decodeToken?.clinic?.patient_origin && origins?.length === 0) {
      return 'Origem de paciente é obrigatória.'
    }

    if (
      decodeToken?.clinic?.patient_document &&
      valueDocumentSelect !== null &&
      !normalizedDocumentNumber
    ) {
      return 'Número do documento do paciente é obrigatório.'
    }

    if (clinicData?.patient_birth_date && !birth_date) {
      return 'Data de nascimento do paciente é obrigatória.'
    }

    if (emailIsRequired) {
      const hasValidEmail = emails.some((item) => item.email?.trim())
      if (!hasValidEmail) {
        return 'E-mail do paciente é obrigatório.'
      }
    }

    const missingDocument = documentsClient.find((document) => {
      if (!document?.is_required) return false
      return !document?.value?.trim() && !document?.valueMask?.trim()
    })

    if (missingDocument) {
      return `Documento obrigatório não preenchido: ${defineNameDocumentByLanguage(
        missingDocument
      )}`
    }

    return null
  }

  const executeMainPatch = async (payload: Record<string, any>, source = 'manual') => {
    if (!state?.id) return false

    const cleanedPayload = removeUndefinedFields(payload)
    const payloadKey = buildPayloadKey(cleanedPayload)

    if (Object.keys(cleanedPayload).length === 0) {
      return false
    }

    if (payloadKey === lastFlushedMainPatchKeyRef.current) {
      console.log('[AUTOSAVE][patient-main] patch ignorado por payload repetido', {
        source,
        cleanedPayload
      })
      return true
    }

    const seq = ++mainSaveSeqRef.current
    lastLocalMainPatchRef.current = {
      at: Date.now(),
      payload: cleanedPayload
    }

    try {
      setAutoSaveError(null)
      setIsAutoSaving(true)
      showAutoSaveSavingToast()

      console.log('[AUTOSAVE][patient-main] enviando patch parcial', {
        seq,
        source,
        payload: cleanedPayload
      })

      const { data: updatedClient } = await apiAuth.patch(
        `clinics/patients/${state.id}/`,
        cleanedPayload
      )

      if (seq < latestAppliedMainSaveSeqRef.current) {
        console.log('[AUTOSAVE][patient-main] resposta antiga ignorada', {
          seq,
          latestApplied: latestAppliedMainSaveSeqRef.current
        })
        return false
      }

      latestAppliedMainSaveSeqRef.current = seq
      lastFlushedMainPatchKeyRef.current = payloadKey
      dirtyRefs.current.cadastro = false

      console.log('[AUTOSAVE][patient-main] salvo com sucesso', {
        seq,
        source,
        updatedClient
      })

      setState((previousClient) =>
        previousClient
          ? {
              ...previousClient,
              ...updatedClient
            }
          : updatedClient
      )

      setLastSavedAt(new Date())
      setMessageChangeForSave(false)
      setAutoSaveError(null)
      lastCadastroPayloadKey.current = buildPayloadKey(updatedClient || {})
      showAutoSaveSuccessToast()
      return true
    } catch (error: any) {
      const message = error?.response?.data?.message || 'Erro ao salvar paciente.'
      setAutoSaveError(message)
      showAutoSaveErrorToast(message)
      console.log('[AUTOSAVE][patient-main] erro', {
        seq,
        source,
        cleanedPayload,
        error
      })
      return false
    } finally {
      setIsAutoSaving(false)
    }
  }

  const flushMainPatch = async (source = 'blur') => {
    if (mainPatchAutoSaveTimer.current) {
      clearTimeout(mainPatchAutoSaveTimer.current)
      mainPatchAutoSaveTimer.current = null
    }

    const payload = {
      ...pendingMainPatchRef.current
    }

    pendingMainPatchRef.current = {}

    if (Object.keys(payload).length === 0) {
      return false
    }

    return executeMainPatch(payload, source)
  }

  const scheduleMainPatch = (partialPayload: Record<string, any>) => {
    if (!isCadastroHydrated) return
    if (tabIndexClient !== 0) return
    if (!state?.id) return
    if (localMethod === 'create') return
    if (isApplyingPatientMqttRef.current) return

    dirtyRefs.current.cadastro = true

    pendingMainPatchRef.current = {
      ...pendingMainPatchRef.current,
      ...partialPayload
    }

    setAutoSaveError(null)

    console.log('[AUTOSAVE][patient-main] alteração enfileirada até blur', {
      partialPayload,
      pendingPayload: pendingMainPatchRef.current
    })
  }

  const saveCadastroClient = async ({
    redirectAfterSave = false,
    showToastOnValidation = false,
    showAutoSaveToasts = false,
    saveRelations = true,
    includeImage = true
  } = {}) => {
    if (!state?.id && localMethod !== 'create') return false

    const values = getValues()
    const data = buildCadastroPayload(values, { includeImage })
    const validationMessage = validateCadastroRequiredFields(data.origins)

    if (validationMessage) {
      clearCadastroAutoSaveTimer()
      setIsAutoSaving(false)
      setAutoSaveError(validationMessage)

      if (showToastOnValidation) {
        toast({
          status: 'error',
          title: 'Campos obrigatórios',
          description: validationMessage,
          duration: 3000,
          position: 'bottom-right'
        })
      }

      if (showAutoSaveToasts) {
        showAutoSaveErrorToast(validationMessage)
      }

      return false
    }

    try {
      if (saveRelations && localMethod !== 'create') {
        await apiAuth.post(`clinics/patients/${state?.id}/telephones/`, data.payloadTelephones)

        await apiAuth.post(
          `clinics/patients/${state?.id}/telephones-whatsapp/`,
          data.payloadTelephonesWhats
        )

        await apiAuth.post(`clinics/patients/${state?.id}/health-insurances/`, data.payloadHeal)

        await apiAuth.post(`clinics/patients/${state?.id}/parents/`, data.payloadParent)

        await apiAuth.post(`clinics/patients/${state?.id}/emails/`, data.payloadEmails)

        await apiAuth.post(`clinics/patients/${state?.id}/addresses/`, data.payloadAddress)
      }

      if (localMethod === 'create') {
        await clientService.createPatients(data.payload)
      } else if (saveRelations || redirectAfterSave) {
        const updatedClient = await clientService.updatePatients(
          data.payload,
          state?.id || '',
          redirectAfterSave
        )
        if (updatedClient) {
          isImageInitializedRef.current = false
          setState(updatedClient)
          if (updatedClient.image) {
            setImgSrc(updatedClient.image)
          }
        }
      } else {
        const { data: updatedClient } = await apiAuth.patch(
          `clinics/patients/${state?.id}/`,
          data.payload
        )

        if (updatedClient) {
          setState((previousClient) =>
            previousClient
              ? {
                  ...previousClient,
                  ...updatedClient
                }
              : updatedClient
          )
        }
      }

      setIsOpenChangeMessage(false)
      setMessageChangeForSave(false)
      setAutoSaveError(null)
      setLastSavedAt(new Date())
      lastCadastroPayloadKey.current = buildPayloadKey(data.payload)

      if (showAutoSaveToasts) {
        showAutoSaveSuccessToast()
      }

      return true
    } catch (error: any) {
      console.log(error)
      const message = error?.response?.data?.message || 'Erro ao salvar paciente.'
      setAutoSaveError(message)

      if (showToastOnValidation) {
        toast({
          status: 'error',
          description: message,
          duration: 3000,
          title: `${t('Error!')}`,
          position: 'bottom-right'
        })
      }

      if (showAutoSaveToasts) {
        showAutoSaveErrorToast(message)
      }

      return false
    }
  }

  const postPatientRelation = async (route: string, payload: any) => {
    if (!state?.id) return false

    const body = Array.isArray(payload) ? payload : []
    await apiAuth.post(`clinics/patients/${state.id}/${route}/`, body)

    return true
  }

  const saveTelephonesOnly = async () => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })
    await postPatientRelation('telephones', data.payloadTelephones)
    lastRelationPayloadKey.current.telephones = buildPayloadKey(data.payloadTelephones || [])
  }

  const saveTelephonesWhatsappOnly = async () => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })
    await postPatientRelation('telephones-whatsapp', data.payloadTelephonesWhats)
    lastRelationPayloadKey.current.telephonesWhatsapp = buildPayloadKey(
      data.payloadTelephonesWhats || []
    )
  }

  const saveEmailsOnly = async () => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })

    if (emailIsRequired) {
      const hasValidEmail = emails.some((item) => item.email?.trim())
      if (!hasValidEmail) {
        throw new Error('E-mail do paciente é obrigatório.')
      }
    }

    await postPatientRelation('emails', data.payloadEmails)
    lastRelationPayloadKey.current.emails = buildPayloadKey(data.payloadEmails || [])
  }

  const saveHealthInsurancesOnly = async () => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })
    await postPatientRelation('health-insurances', data.payloadHeal)
    lastRelationPayloadKey.current.healthInsurances = buildPayloadKey(data.payloadHeal || [])
  }

  const saveParentsOnly = async () => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })
    await postPatientRelation('parents', data.payloadParent)
    lastRelationPayloadKey.current.parents = buildPayloadKey(data.payloadParent || [])
  }

  const saveAddressesOnly = async () => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })
    await postPatientRelation('addresses', data.payloadAddress)
    lastRelationPayloadKey.current.addresses = buildPayloadKey(data.payloadAddress || [])
  }

  const getRelationPayloadByKey = (key: string) => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })

    switch (key) {
      case 'telephones':
        return data.payloadTelephones || []
      case 'telephonesWhatsapp':
        return data.payloadTelephonesWhats || []
      case 'emails':
        return data.payloadEmails || []
      case 'healthInsurances':
        return data.payloadHeal || []
      case 'parents':
        return data.payloadParent || []
      case 'addresses':
        return data.payloadAddress || []
      default:
        return []
    }
  }

  const saveRelationByKey = async (key: string) => {
    if (!dirtyRefs.current[key]) return false

    const payload = getRelationPayloadByKey(key)
    const payloadKey = buildPayloadKey(payload || [])

    if (payloadKey === lastRelationPayloadKey.current[key]) {
      dirtyRefs.current[key] = false
      return true
    }

    try {
      setAutoSaveError(null)
      setIsAutoSaving(true)
      showAutoSaveSavingToast()

      console.log('[AUTOSAVE][patient-relation] enviando no blur', {
        key,
        payload
      })

      switch (key) {
        case 'telephones':
          await postPatientRelation('telephones', payload)
          break
        case 'telephonesWhatsapp':
          await postPatientRelation('telephones-whatsapp', payload)
          break
        case 'emails':
          if (emailIsRequired) {
            const hasValidEmail = emails.some((item) => item.email?.trim())
            if (!hasValidEmail) {
              throw new Error('E-mail do paciente é obrigatório.')
            }
          }
          await postPatientRelation('emails', payload)
          break
        case 'healthInsurances':
          await postPatientRelation('health-insurances', payload)
          break
        case 'parents':
          await postPatientRelation('parents', payload)
          break
        case 'addresses':
          await postPatientRelation('addresses', payload)
          break
        default:
          return false
      }

      lastRelationPayloadKey.current[key] = payloadKey
      pendingRelationPayloadKeyRef.current[key] = payloadKey
      dirtyRefs.current[key] = false
      setLastSavedAt(new Date())
      setAutoSaveError(null)
      showAutoSaveSuccessToast()
      return true
    } catch (error: any) {
      const message = error?.message || 'Erro ao salvar dados do paciente.'
      setAutoSaveError(message)
      showAutoSaveErrorToast(message)
      console.log('[AUTOSAVE][patient-relation] erro', {
        key,
        payload,
        error
      })
      return false
    } finally {
      setIsAutoSaving(false)
    }
  }

  const flushDirtyRelations = async (source = 'blur') => {
    if (!isCadastroHydrated) return
    if (tabIndexClient !== 0) return
    if (!state?.id) return
    if (localMethod === 'create') return
    if (isApplyingPatientMqttRef.current) return

    const dirtyKeys = Object.keys(dirtyRefs.current).filter(
      (key) => key !== 'cadastro' && dirtyRefs.current[key]
    )

    if (dirtyKeys.length === 0) return

    console.log('[AUTOSAVE][patient-relation] flush iniciado', {
      source,
      dirtyKeys
    })

    for (const key of dirtyKeys) {
      await saveRelationByKey(key)
    }
  }

  const scheduleRelationAutoSave = ({
    key,
    payloadKey
  }: {
    key: string
    payloadKey: string
    save: () => Promise<void>
  }) => {
    if (!isCadastroHydrated) return
    if (tabIndexClient !== 0) return
    if (!state?.id) return
    if (localMethod === 'create') return
    if (isApplyingPatientMqttRef.current) return
    if (!dirtyRefs.current[key]) return

    pendingRelationPayloadKeyRef.current[key] = payloadKey

    console.log('[AUTOSAVE][patient-relation] alteração enfileirada até blur', {
      key,
      payloadKey
    })
  }

  const handleCadastroFieldFocus = () => {
    isCadastroFieldFocusedRef.current = true
  }

  const handleCadastroFieldBlurCapture = (event: React.FocusEvent<HTMLDivElement>) => {
    const nextFocusedElement = event.relatedTarget as Node | null
    const isStillInsideCadastro = Boolean(
      nextFocusedElement && cadastroFormRef.current?.contains(nextFocusedElement)
    )

    window.setTimeout(async () => {
      await flushMainPatch('field-blur')
      await flushDirtyRelations('field-blur')

      if (!isStillInsideCadastro) {
        isCadastroFieldFocusedRef.current = false

        if (pendingPatientRealtimeRefreshRef.current) {
          console.log(
            '[MQTT][patient-updated] aplicando refresh pendente após usuário sair do foco'
          )
          pendingPatientRealtimeRefreshRef.current = false

          isApplyingPatientMqttRef.current = true
          try {
            const updatedClient = await GetClient()
            await getPatientRelations()

            if (updatedClient) {
              console.log('[MQTT][patient-updated] snapshot atualizado após pausa', updatedClient)
            }
          } finally {
            setTimeout(() => {
              isApplyingPatientMqttRef.current = false
            }, 300)
          }
        }
      }
    }, 0)
  }

  const handleUpdateClient: SubmitHandler<FormData> = async () => {
    await saveCadastroClient({
      redirectAfterSave: redirect,
      showToastOnValidation: true,
      saveRelations: true,
      includeImage: true
    })
  }

  const handleUpdateClientOnSave = async () => {
    setIsLoadingOperation(true)
    try {
      await saveCadastroClient({
        redirectAfterSave: false,
        showToastOnValidation: true,
        saveRelations: true,
        includeImage: true
      })
    } finally {
      setIsLoadingOperation(false)
    }
  }

  // O cadastro principal agora é salvo por PATCH parcial no próprio onChange dos campos.
  // Esse fluxo evita enviar um payload completo antigo e previne o efeito de "vai e volta".

  useEffect(() => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })

    scheduleRelationAutoSave({
      key: 'telephones',
      payloadKey: buildPayloadKey(data.payloadTelephones || []),
      save: saveTelephonesOnly
    })
  }, [numbers])

  useEffect(() => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })

    scheduleRelationAutoSave({
      key: 'telephonesWhatsapp',
      payloadKey: buildPayloadKey(data.payloadTelephonesWhats || []),
      save: saveTelephonesWhatsappOnly
    })
  }, [numbersWhats])

  useEffect(() => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })

    scheduleRelationAutoSave({
      key: 'emails',
      payloadKey: buildPayloadKey(data.payloadEmails || []),
      save: saveEmailsOnly
    })
  }, [emails, emailIsRequired])

  useEffect(() => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })

    scheduleRelationAutoSave({
      key: 'healthInsurances',
      payloadKey: buildPayloadKey(data.payloadHeal || []),
      save: saveHealthInsurancesOnly
    })
  }, [healthInsurance])

  useEffect(() => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })

    scheduleRelationAutoSave({
      key: 'parents',
      payloadKey: buildPayloadKey(data.payloadParent || []),
      save: saveParentsOnly
    })
  }, [patientRelatives])

  useEffect(() => {
    const data = buildCadastroPayload(getValues(), { includeImage: false })

    scheduleRelationAutoSave({
      key: 'addresses',
      payloadKey: buildPayloadKey(data.payloadAddress || []),
      save: saveAddressesOnly
    })
  }, [
    address.cep,
    address.address,
    address.bairro,
    address.municipio,
    address.ufDefault,
    address.seletedState,
    address.seletedCountry,
    numberAddress,
    complement,
    stateAddress
  ])

  // get filters specialist
  const getFiltersSpecialist = (values: String[]) => {
    setSpecialistIds(values)
  }

  // return hours format
  const hoursFormat = (myDate: string) => {
    if (myDate === null) {
      return ''
    }

    const formatDate = myDate.substring(11, 16)
    return formatDate
  }

  // return date format
  const dateFormat = (myDate: string) => {
    if (myDate === null) {
      return ''
    }

    const formatDate = format(new Date(myDate), 'dd/MM/yyyy', {
      locale: LocaleApp
    })

    return formatDate
  }

  // attendances get all attendances
  useEffect(() => {
    setIsLoadingAttendance(true)
    apiAuth
      .get<GetAttendances>(`clinics/attendances/`, {
        params: {
          is_active: true,
          page: currentPageAttendance,
          patientId: params.id,
          orderBy: '-scheduled_initial_time',
          specialistId: specialistIds.join(','),
          status: statusParam.join(',')
        }
      })
      .then((response) => {
        setAttendance(response.data.results)
        setTotalOfRegisterAttendance(response.data.count)
        setNotes(response?.data?.results[0]?.notes)
      })
      .finally(() => {
        setIsLoadingAttendance(false)
      })

    return () => {}
  }, [specialistIds, statusParam, currentPageAttendance])

  // medical records get all function
  const getAllMedicalRecordsValues = async () => {
    setIsLoadingMedicalRecords(true)
    const { data: medicalRecord } = await apiAuth.get<GetMedicalRecordsData>(
      `clinics/patients/${params.id}/medical-records/`,
      {
        params: {
          start_date: medicalStartDate !== '' ? `${medicalStartDate}T00:00:00` : '',
          finish_date: medicalEndDate !== '' ? `${medicalEndDate}T23:59:59` : '',
          keyword: medicalKeyword,
          fields: `${medicalTypeDataFilter.join(
            ','
          )},finish_date,services_performed,services_not_performed,specialist,attendance_id,sessions,sessions_not_performed`,
          specialistId: medicalRecordsSpecialist.join(','),
          noPaginate: '1'
        }
      }
    )
    const { data: records } = await apiAuth.get<GetRecordsData>(
      `clinics/patients/${params.id}/records/`,
      {
        params: {
          start_date: medicalStartDate !== '' ? `${medicalStartDate}T00:00:00` : '',
          finish_date: medicalEndDate !== '' ? `${medicalEndDate}T23:59:59` : '',
          keyword: medicalKeyword,
          fields: `${medicalTypeDataFilter.join(',')},start_date,finish_date,specialist,id`,
          specialistId: medicalRecordsSpecialist.join(','),
          noPaginate: '1'
        }
      }
    )

    const formattedRecords: MedicalRecords[] = records
      ?.map((record) => {
        return {
          attendance_id: 0,
          id: record?.id,
          finish_date: record?.finish_date,
          specialist: {
            id: record?.specialist?.specialist_id,
            social_name: record?.specialist?.specialist_social_name
          },
          start_date: record?.start_date,
          exams: record?.exams,
          forms: record?.forms,
          indications: record?.indications,
          prescriptions: record?.prescriptions,
          services_not_performed: [],
          services_performed: [],
          sessions_not_performed: [],
          sessions: []
        }
      })
      .sort((a, b) => {
        const dateA = new Date(a.finish_date).getTime()
        const dateB = new Date(b.finish_date).getTime()

        return dateB - dateA
      })

    const allRecords = [...medicalRecord, ...formattedRecords].sort((a, b) => {
      const dateA = new Date(a.finish_date).getTime()
      const dateB = new Date(b.finish_date).getTime()

      return dateB - dateA
    })

    console.log(allRecords)
    setMedicalRecords(allRecords)
    setIsLoadingMedicalRecords(false)
  }

  // medical records get all
  useEffect(() => {
    setIsLoadingMedicalRecords(true)
    const getAllRecords = async () => {
      const { data: medicalRecord } = await apiAuth.get<GetMedicalRecordsData>(
        `clinics/patients/${params.id}/medical-records/`,
        {
          params: {
            start_date: medicalStartDate !== '' ? `${medicalStartDate}T00:00:00` : '',
            finish_date: medicalEndDate !== '' ? `${medicalEndDate}T23:59:59` : '',
            keyword: medicalKeyword,
            fields: `${medicalTypeDataFilter.join(
              ','
            )},finish_date,services_performed,services_not_performed,specialist,attendance_id,sessions,sessions_not_performed`,
            specialistId: medicalRecordsSpecialist.join(','),
            noPaginate: '1'
          }
        }
      )
      const { data: records } = await apiAuth.get<GetRecordsData>(
        `clinics/patients/${params.id}/records/`,
        {
          params: {
            start_date: medicalStartDate !== '' ? `${medicalStartDate}T00:00:00` : '',
            finish_date: medicalEndDate !== '' ? `${medicalEndDate}T23:59:59` : '',
            keyword: medicalKeyword,
            fields: `${medicalTypeDataFilter.join(',')},start_date,finish_date,specialist,id`,
            specialistId: medicalRecordsSpecialist.join(','),
            noPaginate: '1'
          }
        }
      )

      const formattedRecords: MedicalRecords[] = records
        ?.map((record) => {
          return {
            attendance_id: 0,
            finish_date: record?.finish_date,
            id: record?.id,
            specialist: {
              id: record?.specialist?.specialist_id,
              social_name: record?.specialist?.specialist_social_name
            },
            start_date: record?.start_date,
            exams: record?.exams,
            forms: record?.forms,
            indications: record?.indications,
            prescriptions: record?.prescriptions,
            services_not_performed: [],
            services_performed: [],
            sessions_not_performed: [],
            sessions: []
          }
        })
        .sort((a, b) => {
          const dateA = new Date(a.finish_date).getTime()
          const dateB = new Date(b.finish_date).getTime()

          return dateB - dateA
        })

      const allRecords = [...medicalRecord, ...formattedRecords].sort((a, b) => {
        const dateA = new Date(a.finish_date).getTime()
        const dateB = new Date(b.finish_date).getTime()

        return dateB - dateA
      })

      setMedicalRecords(allRecords)
      console.log(allRecords)
      setIsLoadingMedicalRecords(false)
    }

    getAllRecords()

    return () => {}
  }, [
    medicalRecordsSpecialist,
    medicalTypeDataFilter,
    medicalStartDate,
    medicalEndDate,
    medicalKeyword
  ])

  // handler init attendance
  async function handlerInitAttendance(index: number, id: number | string) {
    const myAttendance = attendance[index]

    myAttendance.status = 6
    myAttendance.real_initial_time = format(new Date(), "yyyy-MM-dd'T'HH':'mm':'ss", {
      locale: LocaleApp
    })

    const data = myAttendance

    const payload = {
      start_date: format(new Date(), "yyyy-MM-dd'T'HH':'mm':'ss", {
        locale: LocaleApp
      })
    }

    try {
      await apiAuth.put(`clinics/attendances/${attendance[index].id}/`, data)
      await apiAuth.patch(`clinics/attendances/${attendance[index].id}/medical-records/`, payload)

      history.push(`/attendance/${id}`)
    } catch (error: any) {
      toast({
        duration: 3000,
        status: 'error',
        title: 'Não foi possível iniciar o atendimento',
        position: 'bottom-right'
      })
    }
  }

  // handler click tab index indication and function get all ind
  async function getAllIndicationsList() {
    setIsLoadingIndications(true)

    try {
      const { data } = await apiAuth.get(`clinics/patients/${params?.id}/indications/`, {
        params: {
          is_active: true,
          specialist_ids: filtersIndication?.specialistIds?.join(',') || '',
          status: filtersIndication?.status?.join(',') || '',
          order_by: filtersIndication?.orderBy || ''
        }
      })

      if (data?.count) {
        setTotalOfRegisterIndication(data?.count)
      }

      if (data?.results) {
        setIndicationsData(data?.results)
      }

      setIsLoadingIndications(false)
    } catch (error: any) {
      console.log(error)
    }

    setIsLoadingIndications(false)
  }

  // handler click tab index indication and function get all bud
  async function getAllBudgetsList() {
    setIsLoadingBudgets(true)

    try {
      const { data } = await apiAuth.get(`clinics/quotes/`, {
        params: {
          patient_id: params?.id,
          specialist_id: filtersBudgets?.specialistIds?.join(',') || '',
          created_at: filtersBudgets?.date || ''
        }
      })

      if (data !== undefined) {
        console.log(data)
      }

      if (data?.count) {
        setTotalOfRegisterBudgets(data?.count)
      }

      if (data?.results) {
        setBudgetsData(data?.results)
      }

      console.log(data)

      setIsLoadingBudgets(false)
    } catch (error: any) {
      console.log(error)
    }

    setIsLoadingBudgets(false)
  }

  // handler click tab index Attendance and function get all attendances paginated
  async function getAllAttendancesList() {
    setIsLoadingAttendance(true)
    const { data } = await apiAuth.get<GetAttendances>(`clinics/attendances/`, {
      params: {
        is_active: true,
        page: currentPageAttendance,
        patientId: params.id,
        orderBy: '-scheduled_initial_time',
        specialistId: specialistIds.join(','),
        status: statusParam.join(',')
      }
    })

    setAttendance(data?.results)
    setTotalOfRegisterAttendance(data?.count)
    setIsLoadingAttendance(false)
  }

  useEffect(() => {
    if (tabIndexClient === 0) {
      if (state?.image !== undefined && state.image !== null) {
        const isNewLocalImage = imgSrc.startsWith('blob:') || imgSrc.startsWith('data:')
        if (!isNewLocalImage) {
          setImgSrc(state.image)
        }
      }
    } else {
      setImgSrc('')
    }

    if (tabIndexClient === 1) {
      getAllAttendancesList()
    }

    if (tabIndexClient === 2) {
      getAllMedicalRecordsValues()
    }

    if (tabIndexClient === 5) {
      getCardsTimeline()
      setNameCard(
        format(new Date(), 'dd/MM/yyyy', {
          locale: LocaleApp
        })
      )
    }

    if (tabIndexClient === 3) {
      getAllIndicationsList()
    }

    if (tabIndexClient === 4) {
      getAllBudgetsList()
    }
  }, [tabIndexClient])

  useEffect(() => {
    // handler click tab index indication and function get all ind
    async function getAllIndicationsListEffect() {
      setIsLoadingIndications(true)

      try {
        const { data } = await apiAuth.get(`clinics/patients/${params?.id}/indications/`, {
          params: {
            is_active: true,
            specialist_ids: filtersIndication?.specialistIds?.join(',') || '',
            status: filtersIndication?.status?.join(',') || '',
            order_by: filtersIndication?.orderBy || ''
          }
        })

        if (data?.count) {
          setTotalOfRegisterIndication(data?.count)
        }

        if (data?.results) {
          setIndicationsData(data?.results)
        }

        setIsLoadingIndications(false)
      } catch (error: any) {
        console.log(error)
      }

      setIsLoadingIndications(false)
    }

    getAllIndicationsListEffect()
  }, [filtersIndication])

  useEffect(() => {
    async function getAllBudgetsListEffect() {
      setIsLoadingBudgets(true)

      try {
        const { data } = await apiAuth.get(`clinics/quotes/`, {
          params: {
            patient_id: params?.id,
            specialist_id: filtersBudgets?.specialistIds?.join(',') || '',
            created_at: filtersBudgets?.date || ''
          }
        })

        if (data !== undefined) {
          console.log(data)
        }

        if (data?.count) {
          setTotalOfRegisterBudgets(data?.count)
        }

        if (data?.results) {
          setBudgetsData(data?.results)
        }

        setIsLoadingBudgets(false)
      } catch (error: any) {
        console.log(error)
      }

      setIsLoadingBudgets(false)
    }

    getAllBudgetsListEffect()
  }, [filtersBudgets])

  useEffect(() => {
    handleGetMethod()
  }, [history.location.pathname])

  const handleUploadPatientImage = async (base64Image: string) => {
    if (!state?.id) return

    try {
      setIsLoadingOperation(true)

      const { data } = await apiAuth.patch(`clinics/patients/${state.id}/`, {
        image: base64Image
      })

      setState((prev) =>
        prev
          ? {
              ...prev,
              image: data?.image || prev.image
            }
          : prev
      )

      clearCadastroAutoSaveTimer()
      setMessageChangeForSave(false)
      setIsAutoSaving(false)
      setAutoSaveError(null)
      setLastSavedAt(new Date())
      lastSavedImageRef.current = base64Image

      toast({
        status: 'success',
        title: 'Imagem atualizada',
        description: 'A foto do paciente foi salva.',
        duration: 2500,
        isClosable: true,
        position: 'bottom-right'
      })
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.image?.[0] ||
        'Não foi possível atualizar a imagem do paciente.'

      setAutoSaveError(message)

      toast({
        status: 'error',
        title: 'Erro ao salvar imagem',
        description: message,
        duration: 3500,
        isClosable: true,
        position: 'bottom-right'
      })
    } finally {
      setIsLoadingOperation(false)
    }
  }

  const handleRemoveClientImage = async () => {
    if (state && state.image) {
      try {
        await apiAuth.patch(`clinics/patients/${state?.id}/`, {
          image: ''
        })
        setState((prev) => (prev ? { ...prev, image: '' } : null))
        setImgSrc('')
        clearCadastroAutoSaveTimer()
        setMessageChangeForSave(false)
        setIsAutoSaving(false)
        setAutoSaveError(null)
        setLastSavedAt(new Date())
        toast({
          status: 'success',
          title: 'Imagem removida com sucesso!',
          duration: 3000,
          position: 'bottom-right'
        })
      } catch (error: any) {
        console.log(error)
        toast({
          status: 'error',
          title: 'Erro ao remover imagem do servidor',
          description: error?.response?.data?.message || '',
          duration: 3000,
          position: 'bottom-right'
        })
      }
    }
  }

  useEffect(() => {
    if (decodeToken === undefined) {
      return
    }

    if (decodeToken.clinic_country === 'Brasil') {
      address.setSeledtedBR(true)
    }

    const country = [decodeToken.clinic_country]
    const ArrayCountry = address.optionsContries

    const SelectedDefault = ArrayCountry.map((count: any) =>
      country.find((cou) => {
        if (cou === count.value) {
          address.setSeletedCountry(count)
        }
      })
    )
  }, [decodeToken])

  // functions maker element html to element React
  const htmlToElement = (html: string) => {
    const Element = parserElement(html || '', {
      trim: true
    })

    return Element === '' ? null : Element
  }

  // functions medical record update states
  // start
  const handlerUpdateStartDateMedicalRecording = (date: string) => {
    setMedicalStartDate(date)
  }
  // end
  const handlerUpdateEndDateMedicalRecording = (date: string) => {
    setMedicalEndDate(date)
  }

  const handlerSelectSpecialistMedicalRecording = (values: string[]) => {
    setMedicalRecordsSpecialist(values)
  }

  const handlerGoToNewRegisterMedical = () => {
    history.push(`/medical/register/${state?.id}`)
  }

  // function navigate card
  const handlerClickInCardToUpdate = (id: string | number) => {
    const dataState = {
      id: state?.id
    }

    history.push(`/update/card/${id}`, dataState)
  }

  // function expanded recording
  const handlerClickButtonView = () => {
    if (arrayOpenTabs?.length === undefined) {
      const arrayNumbers = medicalRecords.map((group, index) => {
        return index
      })
      setArrayOpenTabs(arrayNumbers)
    } else {
      setArrayOpenTabs(undefined)
    }
  }

  // function return boolean value for button add medical record
  const returnValidateViewButtonAddMedicalRecord = (finishDate: string) => {
    const result = Math.abs(new Date(finishDate).getTime() - new Date().getTime()) / 3600000
    if (result <= 24) {
      return true
    }

    return false
  }

  if (state === null) {
    return (
      <Box overflow="hidden" position="relative">
        <Header>
          <Flex
            mx="auto"
            w="100%"
            direction="row"
            d="flex"
            my="6"
            align="center"
            justify="space-around"
          >
            <Box mx="auto">
              <Text fontSize="24px" fontWeight="600" height="100%">
                {localMethod === 'create' ? t('create.title') : `${t('updateTitle')}`}
              </Text>
            </Box>
            <Stack direction="row" align="center" justify="center">
              <ArrowBack
                backContext={backContext}
                isChangeForm={messageChangeForSave}
                isChangeFormReturning={(valueBoolean) => setIsOpenChangeMessage(valueBoolean)}
              />
            </Stack>
          </Flex>
        </Header>
        <Sidebar />
        <Flex
          flex="1"
          align="center"
          justify="center"
          mx="auto"
          as="form"
          ml="75px"
          mt="15px"
          mb="8px"
          mr="2"
          bg="white"
          h="cal(100vh - 60px)"
        >
          <Flex w="100vw" h="100vh" align="center" justify="center">
            <Spinner color="blue" />
          </Flex>
        </Flex>
      </Box>
    )
  }

  // handler change indication in tab indication
  const handlerUpdateIndication = async () => {
    const payload = {
      indication_date: `${dateIndication}T00:00:00`,
      observation: observationInd !== '' ? observationInd : null,
      status: statusChangeIndication,
      service: {
        id: idServiceIndication
      }
    }

    try {
      const { data } = await apiAuth.put(
        `/clinics/medical-record-indications/${idIndication}/`,
        payload
      )

      if (data) {
        toast({
          duration: 3000,
          variant: 'solid',
          title: 'Atualização realizada',
          status: 'success',
          description: 'Atualizando a lista de indicações',
          position: 'bottom-right'
        })

        await getAllIndicationsList()

        setIsOpenEditIndication(false)
      }
    } catch (error: any) {
      toast({
        duration: 3000,
        variant: 'solid',
        title: 'Não foi possível atualizar',
        status: 'error',
        position: 'bottom-right'
      })
    }
  }

  return (
    <Box overflow="hidden" position="relative">
      <Header>
        <Flex
          mx="auto"
          w="100%"
          direction="row"
          display="flex"
          my="6"
          align="center"
          justify="space-around"
        >
          <Flex mx="auto" flexDirection="row">
            <Flex mx="auto" align="center" justify="center">
              <Text mx="2" fontSize="24px" fontWeight="600" height="100%">
                {localMethod === 'create' ? t('create.title') : ``}
              </Text>
              <FiUser />
              {isWideVersion ? (
                <Text align="end" mx="2" fontSize="18px">{`${state?.name}`}</Text>
              ) : null}
              <Box>
                <Link
                  to={{
                    pathname: '/financial/daily-box',
                    state: {
                      patient_id: params?.id,
                      patient_name: state?.name
                    }
                  }}
                >
                  <Tooltip
                    label="Atalho para tickets do paciente"
                    aria-label="Atalho para tickets do paciente"
                  >
                    <Flex flexDir="row" justifyContent="center" alignItems="center">
                      <FiDollarSign size={20} />
                      <Text fontSize="12px" fontFamily="cursive">
                        Financeiro
                      </Text>
                    </Flex>
                  </Tooltip>
                </Link>
              </Box>
            </Flex>
          </Flex>
          <Stack direction="row" align="center" justify="center">
            <ArrowBack
              backContext={backContext}
              isChangeForm={messageChangeForSave}
              isChangeFormReturning={(valueBoolean) => setIsOpenChangeMessage(valueBoolean)}
            />
          </Stack>
        </Flex>
      </Header>
      <Sidebar />
      <>
        <Flex
          flex="1"
          position="relative"
          mx="auto"
          as="form"
          ml={isWideVersion ? '75px' : '2'}
          mt="15px"
          mb="8px"
          mr="2"
          bg="white"
          h="cal(100vh - 60px)"
          onSubmit={handleSubmit(handleUpdateClient)}
        >
          <Tabs
            onChange={(event) => setTabIndexClient(event)}
            isFitted
            defaultIndex={tabIndexClient}
            variant="soft-rounded"
            colorScheme="blue"
            w="100%"
          >
            <TabList mb="1em">
              <Tab>{t('tabs.1')}</Tab>
              <Tab>{t('tabs.2')}</Tab>
              <Tab>{t('tabs.3')}</Tab>
              <Tab>{t('tabs.4')}</Tab>
              <Tab>{t('tabs.5')}</Tab>
              <Tab>{t('tabs.6')}</Tab>
              {/* <Tab isDisabled _hover={{ cursor: 'not-allowed' }}>
                {t('tabs.6')}
              </Tab> */}
            </TabList>
            <TabPanels>
              <TabPanel
                ref={cadastroFormRef}
                onFocusCapture={handleCadastroFieldFocus}
                onBlurCapture={handleCadastroFieldBlurCapture}
              >
                <Stack spacing="4" w="100%">
                  <CardContainer
                    title={t('pageClients.PageNovoCliente.containerOne.titleContainer')}
                  >
                    <Box position="absolute" top="4" right="4">
                      <Tooltip
                        label={t('pageClients.PageNovoCliente.containerOne.isActive')}
                        aria-label={t('pageClients.PageNovoCliente.containerOne.isActive')}
                      >
                        <Box>
                          <Switch
                            name="is_active"
                            isChecked={is_active}
                            onChange={(event) => {
                              const nextValue = event.target.checked
                              setIsActive(nextValue)
                              scheduleMainPatch({ is_active: nextValue })
                            }}
                          />
                        </Box>
                      </Tooltip>
                    </Box>
                    <Flex flexDirection="row">
                      <Flex flexDirection="column">
                        {/* Image for user */}
                        {imgSrc ? (
                          <ImageComponent onRemove={handleRemoveClientImage} />
                        ) : (
                          <Dropzone onImageSelected={handleUploadPatientImage} />
                        )}
                        {/* Open Modal Webcam */}
                        <Button
                          size="md"
                          fontSize="md"
                          bg="blue.300"
                          color="#fff"
                          onClick={() => setIsOpen(true)}
                        >
                          {t('pageClients.PageNovoCliente.btnWebcam')}
                        </Button>
                      </Flex>
                      <Flex w="100%" ml="6" flexDirection="column" justify="space-around">
                        <SimpleGrid minChildWidth="320px">
                          <Stack direction="row" my="2" spacing="6">
                            <Box w="50%">
                              <Input
                                label={t('pageClients.PageNovoCliente.containerOne.iNome')}
                                isRequired={is_active}
                                name="name"
                                value={name}
                                onChange={(event) => {
                                  const nextValue = event.currentTarget.value.toUpperCase()
                                  setName(nextValue)
                                  scheduleMainPatch({ name: nextValue })
                                }}
                              />
                            </Box>
                            <Box w="240px">
                              <Input
                                label={t('pageClients.PageNovoCliente.containerOne.iSocialName')}
                                isRequired={is_active}
                                name="socialName"
                                value={socialName}
                                maxLength={20}
                                onChange={(event) => {
                                  const nextValue = event.currentTarget.value.toUpperCase()
                                  setSocialName(nextValue)
                                  scheduleMainPatch({ social_name: nextValue })
                                }}
                              />
                            </Box>
                          </Stack>
                        </SimpleGrid>

                        <Stack direction="row" my="2" spacing="6" w="100%">
                          <Box w="200px">
                            <Input
                              label={t('pageClients.PageNovoCliente.containerOne.iDataNasc')}
                              type="date"
                              handleChange={(e) => {
                                setBirthDate(e.target.value)
                                handleDefinedAge(e)
                                scheduleMainPatch({ birth_date: e.target.value || null })
                              }}
                              isRequired={decodeToken?.clinic?.patient_birth_date && is_active}
                              name="birth_date"
                              value={birth_date}
                              defaultValue={state?.birth_date}
                            />
                          </Box>
                          <Box w="100px">
                            <Input
                              label={t('pageClients.PageNovoCliente.containerOne.iIdade')}
                              disabled
                              value={ageUser}
                              name="age"
                            />
                          </Box>
                          {/* <Box w="30%">
                            <SelectComponent
                              title={t(
                                'pageClients.PageNovoCliente.containerOne.iTDoc'
                              )}
                              placeholder="Ex: CPF"
                              value={valueDocumentSelect}
                              isRequired={
                                decodeToken?.clinic?.patient_document &&
                                is_active
                              }
                              onChange={(event: DocumentSelect) => {
                                setMessageChangeForSave(true)
                                setValueDocumentSelect(event)

                                setTypeDocument(event?.regex)
                              }}
                              options={documents}
                              name="document_type"
                            />
                          </Box>
                          <Box w="30%">
                            <TextFieldControlled
                              label={t(
                                'pageClients.PageNovoCliente.containerOne.iDoc'
                              )}
                              mask={typeDocument}
                              textAlign="left"
                              isRequired={
                                decodeToken?.clinic?.patient_document &&
                                is_active
                              }
                              placeholder={t(
                                'pageClients.PageNovoCliente.containerOne.iDoc'
                              )}
                              name="document_number"
                              initialValue={numberDocument}
                              onKeyUp={(
                                event: React.KeyboardEvent<HTMLInputElement>
                              ) => {
                                setMessageChangeForSave(true)
                                setNumberDocument(event.currentTarget.value)
                              }}
                            />
                          </Box> */}
                          <Flex
                            p="4"
                            border="1px solid #d1d1d6"
                            flexDirection="column"
                            borderRadius={8}
                          >
                            <Flex align="flex-start" justify="flex-start" mb="4">
                              <Text>{t('pageClients.PageNovoCliente.containerOne.iSexo')}</Text>
                            </Flex>
                            <RadioGroup
                              value={sex}
                              onChange={(event) => {
                                setSex(event)
                                scheduleMainPatch({ sex: Number(event) || null })
                              }}
                            >
                              <Stack spacing={4} direction="row">
                                <ChakraRadio value="1">
                                  {t('pageClients.PageNovoCliente.containerOne.TiposSexo.m')}
                                </ChakraRadio>
                                <ChakraRadio value="2">
                                  {t('pageClients.PageNovoCliente.containerOne.TiposSexo.f')}
                                </ChakraRadio>
                              </Stack>
                            </RadioGroup>
                          </Flex>
                        </Stack>
                      </Flex>
                    </Flex>

                    <Stack direction="row" my="2" spacing="6">
                      <Box w="50%">
                        <Input
                          label={t('pageClients.PageNovoCliente.containerOne.iTrabalho')}
                          {...register('occupation')}
                          defaultValue={state?.ocuppation}
                          onChange={(event) => {
                            const nextValue = event.target.value
                            setOccupation(nextValue)
                            scheduleMainPatch({ ocuppation: normalizeOptionalString(nextValue) })
                          }}
                          error={errors.occupation}
                        />
                      </Box>
                      <Box w="50%">
                        <SelectComponent
                          title="Origens"
                          options={originsUpdate.map((origin) => {
                            return {
                              value: origin.id,
                              label: origin.name
                            }
                          })}
                          placeholder={t('placeholder.origins')}
                          isRequired={decodeToken?.clinic?.patient_origin && is_active}
                          isMulti
                          value={patientsOrigins}
                          onChange={(event: any) => {
                            handleSelectedOrigins(event)
                            scheduleMainPatch({
                              origins: Array.isArray(event)
                                ? event.map((item: any) => Number(item.value))
                                : []
                            })
                          }}
                          name="origins"
                          noOptionsText="Nenhuma origem encontrada"
                        />
                      </Box>
                    </Stack>

                    <Stack direction="row" my="2" spacing="6">
                      <Box w="100%">
                        <SelectComponent
                          title="Tags"
                          options={tagsUpdate.map((tag) => {
                            return {
                              value: Number(tag.id),
                              label: String(tag.name)
                            }
                          })}
                          isMulti
                          placeholder={t('placeholder.tags')}
                          value={patientsTags}
                          onChange={(event: any) => {
                            const nextTags = normalizeSelectedOptions(event)

                            console.log('[TAGS][onChange]', {
                              event,
                              nextTags,
                              payload: nextTags.map((item: any) => Number(item.value))
                            })

                            setPatientsTags(nextTags)

                            scheduleMainPatch({
                              patient_tags: nextTags.map((item: any) => Number(item.value))
                            })
                          }}
                          name="tags"
                          noOptionsText="Nenhuma tag encontrada"
                        />
                      </Box>
                    </Stack>

                    <Stack direction="row" my="2" spacing="6">
                      <Box w="100%">
                        <Text fontSize="sm" my="2">
                          {t('pageClients.PageNovoCliente.containerOne.iObsMedical')}
                        </Text>
                        <Textarea
                          value={alertsClient}
                          onChange={(event) => {
                            const nextValue = event.target.value

                            setAlertsClient(nextValue)

                            scheduleMainPatch({
                              alerts: normalizeOptionalString(nextValue)
                            })
                          }}
                          placeholder={t('placeholder.observationMedical')}
                        />
                      </Box>
                      <Box w="100%">
                        <Text fontSize="sm" my="2">
                          {t('pageClients.PageNovoCliente.containerOne.iObs')}
                        </Text>
                        <Textarea
                          value={observationClient}
                          onChange={(event) => {
                            const nextValue = event.target.value

                            setObservationClient(nextValue)

                            scheduleMainPatch({
                              observation: normalizeOptionalString(nextValue)
                            })
                          }}
                          placeholder={t('placeholder.observation')}
                        />
                      </Box>
                    </Stack>
                  </CardContainer>

                  <CardContainer title={t('pageClients.PageNovoCliente.documents.title')}>
                    <Stack my="2" spacing="6">
                      {documentsClient?.length === 0 && (
                        <Text>{t('pageClients.PageNovoCliente.documents.warning')}</Text>
                      )}
                      {documentsClient?.map((document, index: number) => (
                        <Stack direction="row" key={`number${index}`}>
                          <Stack direction="row" w="320px">
                            <TextFieldControlled
                              label={defineNameDocumentByLanguage(document)}
                              type="text"
                              textAlign="left"
                              placeholder=""
                              size="md"
                              name="document_preferences"
                              mask={document?.regex || 'def'}
                              isRequired={document?.is_required}
                              initialValue={document?.valueMask}
                              inputOnChange={(e) => {
                                const allDocumentsValues = documentsClient.map(
                                  (item, itemIndex) => {
                                    if (itemIndex !== index) return item

                                    return {
                                      ...item,
                                      value: remaskCaractersAll(e.currentTarget.value),
                                      valueMask: e.currentTarget.value
                                    }
                                  }
                                )

                                setDocumentsClient(allDocumentsValues)
                                scheduleMainPatch({
                                  documents: normalizeDocumentsForPayload(allDocumentsValues)
                                })
                              }}
                            />
                          </Stack>
                        </Stack>
                      ))}
                    </Stack>
                  </CardContainer>

                  <CardContainer title={t('pageClients.PageNovoCliente.containerTwo.title')}>
                    <Stack my="2" spacing="6">
                      {numbers.map((number, index: number) => (
                        <Stack direction="row" key={`number${index}`}>
                          <Stack direction="row" w="100%">
                            <InputPhone2
                              label={`${t('pageClients.PageNovoCliente.containerTwo.tele')} ${
                                index + 1
                              }`}
                              defaultValues={{
                                ddi: numbers[index].ddi_country
                              }}
                              type="text"
                              size="md"
                              name="number"
                              getValues={(value) => {
                                const values = [...numbers]
                                values[index].ddi_country = value?.ddi_country
                                setNumbers(values)
                              }}
                              value={numbers[index].contact}
                              onChange={(e) => handleChangeInputNumbers(index, e)}
                            />
                            {numbers[index].contact.length > 5 && (
                              <Input
                                name="descriptionContact"
                                value={numbers[index].description}
                                label={t('pageClients.PageNovoCliente.containerTwo.description')}
                                onChange={(event) => handlerChangeDescriptionContact(index, event)}
                              />
                            )}
                            {/*                       <Flex
                        pt="4"
                        direction="column"
                        align="center"
                        justify="center"
                      >
                        {numbers.length > 1 && (
                          <Box>
                            <Button
                              type="button"
                              colorScheme="red"
                              size="xs"
                              onClick={() => handleRemoveNumbers(index)}
                              mb="2"
                            >
                              -
                            </Button>
                          </Box>
                        )}
                        <Box>
                          <Button
                            bg="green.400"
                            color="#fff"
                            _hover={{
                              bg: 'green.400',
                              filter: 'brightness(0.7)'
                            }}
                            _active={{
                              bg: 'green.400',
                              filter: 'brightness(0.7)'
                            }}
                            type="button"
                            size="xs"
                            onClick={() => handleAddNumbers()}
                          >
                            +
                          </Button>
                        </Box>
                      </Flex> */}
                          </Stack>
                        </Stack>
                      ))}
                    </Stack>
                  </CardContainer>

                  <CardContainer title={t('pageClients.PageNovoCliente.containerTwoWhats.title')}>
                    <Box position="absolute" top="4" right="4">
                      <Tooltip
                        label={t('pageClients.PageNovoCliente.containerTwoWhats.isAccept')}
                        aria-label={t('pageClients.PageNovoCliente.containerTwoWhats.isAccept')}
                      >
                        <Box>
                          <Switch
                            name="is_accept_contact"
                            isChecked={is_accept}
                            onChange={(event) => {
                              const nextValue = event.target.checked
                              setIsAccept(nextValue)
                              scheduleMainPatch({ allow_whatsapp: nextValue })
                            }}
                          />
                        </Box>
                      </Tooltip>
                    </Box>
                    <Stack my="2" spacing="6">
                      {numbersWhats.map((number, index: number) => (
                        <Stack direction="row" key={`number${index}`}>
                          <Stack direction="row" w="100%">
                            <InputPhone2
                              label={`${t('pageClients.PageNovoCliente.containerTwoWhats.tele')} ${
                                index + 1
                              }`}
                              defaultValues={{
                                ddi: numbersWhats[index].ddi_country
                              }}
                              type="text"
                              size="md"
                              name="number"
                              getValues={(value) => {
                                const values = [...numbersWhats]
                                values[index].ddi_country = value?.ddi_country
                                setNumbersWhats(values)
                              }}
                              value={numbersWhats[index].contact}
                              onChange={(e) => handleChangeInputNumbersWhats(index, e)}
                            />
                            {numbersWhats[index].contact.length > 5 && (
                              <Input
                                name="descriptionContact"
                                value={numbersWhats[index].description}
                                label={t(
                                  'pageClients.PageNovoCliente.containerTwoWhats.description'
                                )}
                                onChange={(event) =>
                                  handlerChangeDescriptionContactWhats(index, event)
                                }
                              />
                            )}
                            {/*                       <Flex
                              pt="4"
                              direction="column"
                              align="center"
                              justify="center"
                            >
                              {numbers.length > 1 && (
                                <Box>
                                  <Button
                                    type="button"
                                    colorScheme="red"
                                    size="xs"
                                    onClick={() => handleRemoveNumbers(index)}
                                    mb="2"
                                  >
                                    -
                                  </Button>
                                </Box>
                              )}
                              <Box>
                                <Button
                                  bg="green.400"
                                  color="#fff"
                                  _hover={{
                                    bg: 'green.400',
                                    filter: 'brightness(0.7)'
                                  }}
                                  _active={{
                                    bg: 'green.400',
                                    filter: 'brightness(0.7)'
                                  }}
                                  type="button"
                                  size="xs"
                                  onClick={() => handleAddNumbers()}
                                >
                                  +
                                </Button>
                              </Box>
                            </Flex> */}
                          </Stack>
                        </Stack>
                      ))}
                    </Stack>
                  </CardContainer>

                  <CardContainer title={t('pageClients.PageNovoCliente.containerEmail.title')}>
                    <Stack direction="row" my="2" spacing="6">
                      <Input
                        label={t('pageClients.PageNovoCliente.containerEmail.email')}
                        name="email"
                        type="email"
                        size="md"
                        isRequired={emailIsRequired}
                        value={emails[0].email}
                        onChange={(event) => handlerChangeEmail(0, event)}
                      />
                      {emails[0].email.length > 5 && (
                        <Input
                          label={t('pageClients.PageNovoCliente.containerEmail.description')}
                          name="descriptionEmail"
                          value={emails[0].description}
                          onChange={(event) => handlerChangeEmailDescription(0, event)}
                        />
                      )}
                    </Stack>
                  </CardContainer>

                  <CardContainer title={t('pageClients.PageNovoCliente.containerThree.title')}>
                    <Stack direction="row" my="2" spacing="2">
                      <Box w="30%">
                        <SelectComponent
                          title={t('pageClients.PageNovoCliente.containerThree.iPais')}
                          placeholder="Selecione um país"
                          options={address.optionsContries}
                          name="pais"
                          value={address.seletedCountry}
                          onChange={(e: any) => {
                            markRelationAsChanged('addresses')
                            address.handleBRSelectedAndShowStates(e)
                          }}
                        />
                      </Box>
                      <Box>
                        <Input
                          label={t('pageClients.PageNovoCliente.containerThree.iCEP')}
                          name="cep"
                          isDisabled={address.loadingCompletAddress}
                          value={cepAddress}
                          onChange={(e) => {
                            markRelationAsChanged('addresses')
                            address.handleCompletAddress(e.target.value)
                            if (e.currentTarget.value.length <= 8) {
                              setCepAddress(e.currentTarget.value)
                            }
                          }}
                        />
                      </Box>
                      <Box w="40%">
                        <Input
                          label={t('pageClients.PageNovoCliente.containerThree.iRua')}
                          name="street"
                          value={address.address}
                          onChange={(e) => {
                            address.setAddress(e.target.value)
                            markRelationAsChanged('addresses')
                          }}
                        />
                      </Box>
                      <Box>
                        <Input
                          label={t('pageClients.PageNovoCliente.containerThree.iNumero')}
                          name="numberAddress"
                          defaultValue={state?.address?.number}
                          onChange={(e) => {
                            setNumberAddress(e.target.value)
                            markRelationAsChanged('addresses')
                          }}
                          value={numberAddress}
                        />
                      </Box>
                    </Stack>
                    <Stack direction="row" my="2" spacing="2">
                      <Box w="30%">
                        <Input
                          label={t('pageClients.PageNovoCliente.containerThree.iComplemento')}
                          value={complement}
                          name="complementAddress"
                          onChange={(e) => {
                            setComplement(e.target.value)
                            markRelationAsChanged('addresses')
                          }}
                        />
                      </Box>
                      <Box>
                        <Input
                          label={t('pageClients.PageNovoCliente.containerThree.iBairro')}
                          name="neighborhood"
                          value={address.bairro}
                          onChange={(e) => {
                            address.setBairro(e.target.value)
                            markRelationAsChanged('addresses')
                          }}
                        />
                      </Box>
                      <Box w="30%">
                        <Input
                          label={t('pageClients.PageNovoCliente.containerThree.iCidade')}
                          name="city"
                          value={address.municipio}
                          onChange={(e) => {
                            address.setMunicipio(e.target.value)
                            markRelationAsChanged('addresses')
                          }}
                        />
                      </Box>
                      {address.selectedBR ? (
                        <Box w="30%">
                          <SelectComponent
                            title={t('pageClients.PageNovoCliente.containerThree.iEstado')}
                            placeholder="Selecione um estado"
                            options={address.ufs}
                            name="estado"
                            value={address.seletedState}
                            onChange={(e: any) => {
                              address.setSelectedState(e)
                              markRelationAsChanged('addresses')
                            }}
                          />
                        </Box>
                      ) : (
                        <Box w="30%">
                          <Input
                            label={t('pageClients.PageNovoCliente.containerThree.iEstado')}
                            name="street"
                            defaultValue={stateAddress}
                            onChange={(e) => {
                              markRelationAsChanged('addresses')
                              setStateAddress(e.target.value)
                            }}
                            textTransform="uppercase"
                            error={errors.state}
                          />
                        </Box>
                      )}
                    </Stack>
                  </CardContainer>

                  <CardContainer title={t('pageClients.PageNovoCliente.containerFive.title')}>
                    <Stack spacing="6">
                      {healthInsurance.map((health, index: number) => (
                        <Stack w="100%" direction="row" my="2" spacing="6" key={`health${index}`}>
                          <Box w="40%">
                            <SelectComponent
                              title={t('pageClients.PageNovoCliente.containerFive.iConvenios')}
                              placeholder={t('placeholder.covenants')}
                              options={covenantsUpdate.map((con) => {
                                return {
                                  value: con.id,
                                  label: con.name
                                }
                              })}
                              value={health.healthInsurance}
                              onChange={(e: any) => {
                                markRelationAsChanged('healthInsurances')
                                handleSelectConvenio(index, e)
                              }}
                              name="health_insurance"
                            />
                          </Box>
                          <Stack direction="row" spacing="4" flex="1">
                            <Box w="100%">
                              <Input
                                label={t('pageClients.PageNovoCliente.containerFive.iNumero')}
                                isRequired={
                                  isRequiredReturnForForm(health.healthInsurance) && is_active
                                }
                                placeholder={t('placeholder.covenantsNumber')}
                                value={health.healthInsuranceNumber || ''}
                                onChange={(e) => {
                                  markRelationAsChanged('healthInsurances')
                                  handleInputConvenio(index, e)
                                }}
                                name="health_insurance_number"
                              />
                            </Box>
                            <Flex pt="4" direction="column" align="center" justify="center">
                              {healthInsurance.length > 1 && (
                                <Box>
                                  <Button
                                    type="button"
                                    colorScheme="red"
                                    size="xs"
                                    onClick={() => {
                                      markRelationAsChanged('healthInsurances')
                                      removeFieldsConvenio(index)
                                    }}
                                    mb="2"
                                  >
                                    -
                                  </Button>
                                </Box>
                              )}
                              <Box>
                                <Button
                                  bg="green.400"
                                  color="#fff"
                                  _hover={{
                                    bg: 'green.400',
                                    filter: 'brightness(0.7)'
                                  }}
                                  _active={{
                                    bg: 'green.400',
                                    filter: 'brightness(0.7)'
                                  }}
                                  type="button"
                                  size="xs"
                                  onClick={() => {
                                    markRelationAsChanged('healthInsurances')
                                    addFieldsConvenio()
                                  }}
                                >
                                  +
                                </Button>
                              </Box>
                            </Flex>
                          </Stack>
                        </Stack>
                      ))}
                    </Stack>
                  </CardContainer>

                  <CardContainer title={t('pageClients.PageNovoCliente.containerFour.title')}>
                    <Stack spacing="6">
                      {patientRelatives.map((patient, index: number) => (
                        <Stack w="100%" direction="row" my="2" spacing="6" key={`patient${index}`}>
                          <Box w="60%">
                            <SelectComponentAsync
                              title={t('pageClients.PageNovoCliente.containerFour.iNome')}
                              placeholder={t('placeholder.family')}
                              loadOptions={(values: string) =>
                                clientService.getClientsServices(values)
                              }
                              value={patient.patientRelatives}
                              onChange={(e: any) => {
                                markRelationAsChanged('parents')
                                handleSelectedRelativesNames(index, e)
                              }}
                              name="patient_relatives"
                            />
                          </Box>
                          <Stack direction="row" spacing="4" flex="1">
                            <Box w="100%">
                              <Select
                                label={t('pageClients.PageNovoCliente.containerFour.iGrauP')}
                                placeholder="Ex: Pai"
                                options={optionsFamily}
                                value={patient.patientDegree}
                                isRequired={
                                  isRequiredReturnForForm(patient.patientRelatives) && is_active
                                }
                                onChange={(e: any) => {
                                  markRelationAsChanged('parents')
                                  handleSelectRelativesFamily(index, e)
                                }}
                                name="patient_degree"
                              />
                            </Box>
                            <Flex pt="4" direction="column" align="center" justify="center">
                              {patientRelatives.length > 1 && (
                                <Box>
                                  <Button
                                    type="button"
                                    colorScheme="red"
                                    size="xs"
                                    onClick={() => {
                                      markRelationAsChanged('parents')
                                      removeFieldsRelatives(index)
                                    }}
                                    mb="2"
                                  >
                                    -
                                  </Button>
                                </Box>
                              )}
                              <Box>
                                <Button
                                  bg="green.400"
                                  color="#fff"
                                  _hover={{
                                    bg: 'green.400',
                                    filter: 'brightness(0.7)'
                                  }}
                                  _active={{
                                    bg: 'green.400',
                                    filter: 'brightness(0.7)'
                                  }}
                                  type="button"
                                  size="xs"
                                  onClick={() => {
                                    markRelationAsChanged('parents')
                                    addFieldsRelatives()
                                  }}
                                >
                                  +
                                </Button>
                              </Box>
                            </Flex>
                          </Stack>
                        </Stack>
                      ))}
                    </Stack>
                  </CardContainer>

                  <Flex mt="6" w="100%" align="center" justifyContent="flex-end" gap={2}>
                    {isAutoSaving ? (
                      <Text fontSize="sm" color="blue.500" fontWeight="semibold">
                        Salvando alterações...
                      </Text>
                    ) : autoSaveError ? (
                      <Text fontSize="sm" color="red.500" fontWeight="semibold">
                        {autoSaveError}
                      </Text>
                    ) : lastSavedAt ? (
                      <Text fontSize="sm" color="green.500" fontWeight="semibold">
                        Alterações salvas às {format(lastSavedAt, 'HH:mm')}
                      </Text>
                    ) : (
                      <Text fontSize="sm" color="gray.500" fontWeight="semibold">
                        As alterações serão salvas automaticamente.
                      </Text>
                    )}
                  </Flex>

                  <Stack w="100%" my="2" h="300px" />
                </Stack>
              </TabPanel>
              <TabPanel>
                <>
                  <Flex flex="1" flexDirection="column">
                    <Flex
                      w="100%"
                      borderBlockEnd="1px solid #e4e4e4"
                      mb="2"
                      pb="2"
                      align="flex-start"
                      justify="space-between"
                      mx="auto"
                    >
                      <Flex flexDirection="row" w="full" justifyContent="left" alignItems="center">
                        <Flex mx="2" w="full" justify="space-around">
                          <Flex mr="2" w="full" align="end">
                            <Button
                              mr="2"
                              bg="blue.300"
                              color="white"
                              onClick={() => setFrontendModel(0)}
                              _hover={{ background: '#215B88' }}
                              style={frontendModel === 0 ? selectedButton : undefined}
                              size="sm"
                            >
                              {t('controlBar.btn1')}
                            </Button>
                            <Button
                              mr="2"
                              bg="blue.300"
                              color="white"
                              onClick={() => setFrontendModel(1)}
                              _hover={{ background: '#215B88' }}
                              style={frontendModel === 1 ? selectedButton : undefined}
                              size="sm"
                            >
                              {t('controlBar.btn2')}
                            </Button>
                          </Flex>
                        </Flex>
                        {frontendModel === 0 && (
                          <>
                            <MultiSelectMenuFilter
                              label="Especialistas"
                              options={clientService.specialists.map((specialist) => {
                                return {
                                  id: String(specialist?.user?.id),
                                  name: specialist?.social_name || specialist.user.name
                                }
                              })}
                              backChange={(values: any) => {
                                getFiltersSpecialist(values)
                              }}
                            />

                            <MultiSelectMenuFilter
                              label="Status"
                              options={statusOptionsDefault.map((itemStatus) => {
                                return {
                                  id: String(itemStatus.value),
                                  name: itemStatus.label
                                }
                              })}
                              backChange={(values: any) => {
                                setStatusParam(values)
                              }}
                            />
                          </>
                        )}
                        <Link
                          to={{
                            pathname: '/scheduling/create',
                            state: {
                              client: {
                                value: state?.id,
                                label: state?.name
                              },
                              today: format(new Date(), 'yyyy-MM-dd', {
                                locale: LocaleApp
                              })
                            }
                          }}
                        >
                          <Button size="md" bg="blue.300" mx="2" mb="2px" color="white">
                            Nova Agenda
                          </Button>
                        </Link>
                        <PermissionComponent ipCode="CREATE" spiCode="NOTES">
                          <Link
                            to={{
                              pathname: '/notes/create',
                              state: {
                                patient: {
                                  value: state?.id,
                                  label: state?.name
                                }
                              }
                            }}
                          >
                            <Button
                              size="md"
                              bg="blue.300"
                              mx="2"
                              mb="2px"
                              color="white"
                              disabled={allowNotes}
                            >
                              Novo Lembrete
                            </Button>
                          </Link>
                        </PermissionComponent>
                        <PermissionComponent ipCode="CREATE" spiCode="NOTES">
                          <Button
                            bg="blue.300"
                            isDisabled={notes?.length === 0}
                            mx="2"
                            mb="2px"
                            color="white"
                            w="120px"
                            size="md"
                            gap="4px"
                            onClick={() => setIsViewModalNote(true)}
                          >
                            <MdSpeakerNotes size={20} />{' '}
                            {attendance?.[0]?.notes?.length > 0 && (
                              <Text>{attendance?.[0]?.notes?.length}</Text>
                            )}
                          </Button>
                        </PermissionComponent>
                        <PermissionComponent ipCode="CREATE" spiCode="NOTES">
                          <Switch
                            mx="2"
                            mb="2"
                            name="allowNotes"
                            isChecked={allowNotes}
                            onChange={() => handlerChangeAllowNote()}
                            label="Não recebe lembretes"
                          />
                        </PermissionComponent>
                      </Flex>
                      <Flex flexDirection="row">
                        <Button mx="2" colorScheme="blue" isDisabled size="sm" onClick={() => {}}>
                          <FiPrinter size={20} />
                        </Button>
                      </Flex>
                    </Flex>
                    {/* content attendances */}
                    {frontendModel === 0 ? (
                      <Flex flex="1" h="100vh" flexDirection="column">
                        {isLoadingAttendance ? (
                          <Center w="100%" p="2">
                            <Spinner size="md" color="blue" />
                          </Center>
                        ) : (
                          <Table variant="striped" colorScheme="blue" size="sm">
                            <Thead>
                              <Tr>
                                <Th>{t('attendance.table.t1')}</Th>
                                <Th>{t('attendance.table.t2')}</Th>
                                <Th>{t('attendance.table.t3')}</Th>
                                <Th>{t('attendance.table.t4')}</Th>
                                {specialistIds.length === 1 ? null : (
                                  <Th>{t('attendance.table.t7')}</Th>
                                )}
                                <Th>{t('attendance.table.t8')}</Th>
                                <Th>{t('attendance.table.t9')}</Th>
                                <Th>{t('attendance.table.t10')}</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {attendance?.map((item, index: number) => (
                                <Tr key={String(item?.id)}>
                                  <Td>
                                    <Text fontSize="sm">
                                      {formatDateBR(
                                        item?.scheduled_arrival_time,
                                        decodeToken.clinic.timezone
                                      )}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize="sm">
                                      {formatHour(
                                        item?.scheduled_arrival_time,
                                        decodeToken.clinic.timezone
                                      )}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text fontSize="sm">
                                      {formatHour(
                                        item?.real_arrival_time,
                                        decodeToken.clinic.timezone
                                      )}
                                    </Text>
                                  </Td>
                                  {item?.status && (
                                    <>
                                      <Td>
                                        <Flex gap="2" flexDir="row">
                                          {item?.status === 1 && (
                                            <Text fontSize="small">{t('attendance.status.1')}</Text>
                                          )}
                                          {item?.status === 2 && (
                                            <Text fontSize="small">{t('attendance.status.2')}</Text>
                                          )}
                                          {item?.status === 3 && (
                                            <Text fontSize="small">{t('attendance.status.3')}</Text>
                                          )}
                                          {item?.status === 4 && (
                                            <Text fontSize="small">{t('attendance.status.4')}</Text>
                                          )}
                                          {item?.status === 5 && (
                                            <Text fontSize="small">{t('attendance.status.5')}</Text>
                                          )}
                                          {item?.status === 6 && (
                                            <Text fontSize="small">{t('attendance.status.6')}</Text>
                                          )}
                                          {item?.status === 7 && (
                                            <Text fontSize="small">{t('attendance.status.7')}</Text>
                                          )}
                                          {item?.status_by_system && (
                                            <Tooltip
                                              label={t('bySystem')}
                                              aria-label={t('bySystem')}
                                              hasArrow
                                              placement="auto-end"
                                            >
                                              <Box>
                                                <Flex
                                                  rounded="full"
                                                  w="14px"
                                                  alignItems="center"
                                                  justifyContent="center"
                                                  h="14px"
                                                  bg="blue.300"
                                                  color="white"
                                                >
                                                  <Text>S</Text>
                                                </Flex>
                                              </Box>
                                            </Tooltip>
                                          )}
                                        </Flex>
                                      </Td>
                                    </>
                                  )}
                                  {specialistIds.length === 1 ? null : (
                                    <Td>
                                      <Text fontSize="smaller">{item?.specialist_name}</Text>
                                    </Td>
                                  )}
                                  <Td>
                                    {item?.attendance_items?.map((service) => (
                                      <Text key={service.id} fontSize="12px" fontWeight="semibold">
                                        {`${service?.service_name} - 1/${service?.total_session}`}
                                      </Text>
                                    ))}
                                    {item?.sessions !== undefined &&
                                      item?.sessions?.map((sec) => (
                                        <Tooltip
                                          key={sec.id}
                                          label={`${sec?.service_name} - ${sec?.session_number}/${sec?.total_session}`}
                                          aria-label={`${sec?.service_name} - ${sec?.session_number}/${sec?.total_session}`}
                                          hasArrow
                                          placement="top-start"
                                        >
                                          <Text
                                            noOfLines={1}
                                            fontSize="12px"
                                            fontWeight="semibold"
                                            _hover={{
                                              cursor: 'default'
                                            }}
                                          >
                                            {`${sec?.service_name} - ${sec?.session_number}/${sec?.total_session}`}
                                          </Text>
                                        </Tooltip>
                                      ))}
                                  </Td>
                                  <Td>
                                    <Stack direction="row">
                                      <Tooltip
                                        label={
                                          <InfoTooltipCard
                                            created_at={(item as any)?.created_at}
                                            updated_at={(item as any)?.updated_at}
                                            created_by={(item as any)?.created_by}
                                            updated_by={(item as any)?.updated_by}
                                          />
                                        }
                                        aria-label="info"
                                        hasArrow
                                        placement="auto-end"
                                      >
                                        <Box>
                                          <FiUser size={16} color="#9699B0" />
                                        </Box>
                                      </Tooltip>
                                      {item?.observation ? (
                                        <Tooltip
                                          label={item?.observation || ''}
                                          aria-label={item?.observation || ''}
                                          hasArrow
                                          placement="auto-end"
                                        >
                                          <Box>
                                            <FcInfo size={20} />
                                          </Box>
                                        </Tooltip>
                                      ) : (
                                        <Box w="20px" />
                                      )}
                                      {returnJsxElementStatusTicket(item?.ticket_status_payment)}
                                      {item?.block_guide ? (
                                        <Tooltip
                                          label={t('attendance.block')}
                                          aria-label={t('attendance.block')}
                                          hasArrow
                                          placement="top-start"
                                        >
                                          <Box>
                                            <AiFillLock size={20} color="red" />
                                          </Box>
                                        </Tooltip>
                                      ) : (
                                        <Tooltip
                                          label={t('attendance.noBlock')}
                                          aria-label={t('attendance.noBlock')}
                                          hasArrow
                                          placement="top-start"
                                        >
                                          <Box>
                                            <AiFillUnlock size={20} color="green" />
                                          </Box>
                                        </Tooltip>
                                      )}
                                    </Stack>
                                  </Td>
                                  <Td>
                                    {Number(decodeToken.user_id) === item?.professional_id &&
                                      verifyStatusAttendanceButton(item?.status) &&
                                      item?.allowed_start_attendance === true && (
                                        <Button
                                          size="md"
                                          h="22px"
                                          fontSize="small"
                                          colorScheme="blue"
                                          onClick={() => {
                                            handlerInitAttendance(index, item?.id)
                                          }}
                                        >
                                          {t('attendance.btnInit')}
                                        </Button>
                                      )}
                                    {Number(decodeToken.user_id) === item?.professional_id &&
                                      item?.status === 6 && (
                                        <Button
                                          size="md"
                                          h="22px"
                                          fontSize="small"
                                          colorScheme="blue"
                                          onClick={() => {
                                            history.push(`/attendance/${item?.id}`, {
                                              state: item
                                            })
                                          }}
                                        >
                                          {t('attendance.btnContinue')}
                                        </Button>
                                      )}
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                        )}
                        {totalOfRegisterAttendance !== 0 && !isLoadingAttendance && (
                          <Pagination
                            totalCountOfRegisters={totalOfRegisterAttendance}
                            currentPage={currentPageAttendance}
                            onPageChange={setCurrentPageAttendance}
                          />
                        )}
                        {attendance?.length === 0 && !isLoadingAttendance && <NotFound />}
                        <Flex w="100%" h="400px" />
                      </Flex>
                    ) : (
                      <Table variant="striped" colorScheme="blue" size="sm">
                        <Thead>
                          <Tr>
                            <Th>{t('sessions.t1')}</Th>
                            <Th>{t('sessions.t4')}</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {sessions?.map((item, index: number) => (
                            <Tr key={String(item?.id)}>
                              <Td>
                                <Text fontSize="sm">
                                  {`${item?.service_name} - ${item?.session_number}/${item?.total_session}`}
                                </Text>
                              </Td>
                              <Td>
                                {item?.status === 1 && (
                                  <Tooltip label={t('Cancel')} aria-label={t('Cancel')}>
                                    <Box
                                      onClick={() => {
                                        setIdSession(item?.id)
                                        setIsOpenCancel(true)
                                      }}
                                      w="10px"
                                    >
                                      <MdFreeCancellation size={18} color="gray" />
                                    </Box>
                                  </Tooltip>
                                )}
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      </Table>
                    )}
                  </Flex>
                  <NotesModal
                    isOpen={isViewModalNote}
                    onClose={() => setIsViewModalNote(false)}
                    notes={notes}
                    setNotes={setNotes}
                    patientName={patientName}
                    patientId={Number(state?.id)}
                  />
                </>
              </TabPanel>
              <TabPanel>
                <>
                  <Flex flex="1" flexDirection="column">
                    <Flex
                      w="100%"
                      borderBlockEnd="1px solid #e4e4e4"
                      mb="2"
                      pb="2"
                      align="flex-start"
                      justify="space-between"
                      mx="auto"
                    >
                      <Flex flexDirection="row" w="90%">
                        <Stack direction="row">
                          <Box w="162px">
                            <Input
                              placeholder={t('recording.filters.startDate')}
                              type="date"
                              value={medicalStartDate}
                              onChange={(event) => {
                                handlerUpdateStartDateMedicalRecording(event.target.value)
                              }}
                              name="filterRecording"
                            />
                          </Box>
                          <Box w="162px">
                            <Input
                              placeholder={t('recording.filters.endDate')}
                              value={medicalEndDate}
                              onChange={(event) => {
                                handlerUpdateEndDateMedicalRecording(event.target.value)
                              }}
                              type="date"
                              name="filterRecording"
                            />
                          </Box>
                          <Box w="162px">
                            <Input
                              placeholder={t('recording.filters.keyword')}
                              name="keywordMedicalRecord"
                              value={medicalKeyword}
                              onChange={(event) => setMedicalKeyword(event.target.value)}
                            />
                          </Box>
                          <MultiSelectMenuFilter
                            label={t('recording.filters.specialist')}
                            options={clientService.specialists.map((specialist) => {
                              return {
                                id: String(specialist?.user?.id),
                                name: specialist?.social_name || specialist.user.name
                              }
                            })}
                            backChange={(values: any) => {
                              handlerSelectSpecialistMedicalRecording(values)
                            }}
                          />

                          <MultiSelectMenuFilter
                            label={t('recording.filters.types')}
                            isDefaultFull
                            options={TypesMedicalData.map((item) => {
                              return {
                                id: String(item?.value),
                                name: item?.label
                              }
                            })}
                            render={() => {
                              const defaultTypes = medicalTypeDataFilter

                              return defaultTypes
                            }}
                            backChange={(values: any) => {
                              setMedicalTypeDataFilter(values)
                            }}
                          />
                        </Stack>
                        <Flex>
                          <Button
                            colorScheme="blue"
                            mx="2"
                            onClick={() => {
                              handlerClickButtonView()
                            }}
                          >
                            {arrayOpenTabs?.length === undefined
                              ? t('recording.expanded')
                              : t('recording.recall')}
                          </Button>
                        </Flex>
                        {decodeToken?.is_specialist && (
                          <Flex>
                            <Button
                              colorScheme="blue"
                              mx="2"
                              onClick={() => {
                                handlerGoToNewRegisterMedical()
                              }}
                            >
                              {t('recording.newMedicalRecording')}
                            </Button>
                          </Flex>
                        )}
                      </Flex>
                    </Flex>
                    {/* content recording  */}
                    {medicalRecords?.length === 0 && !isLoadingMedicalRecords ? (
                      <NotFound />
                    ) : (
                      <Flex flex="1" h="100vh" flexDirection="column">
                        <>
                          <Flex w="100%" flexDirection="column" gap={2}>
                            <Stack
                              w="100%"
                              display="flex"
                              flexDirection="row"
                              justifyContent="space-around"
                              alignItems="center"
                            >
                              <Box w="25%">
                                <Text textAlign="center" mx="2">
                                  {t('recording.table.t1')}
                                </Text>
                              </Box>
                              <Box w="25%">
                                <Text textAlign="center" mx="2">
                                  {t('recording.table.t2')}
                                </Text>
                              </Box>
                              <Box w="25%">
                                <Text mx="2">{t('recording.table.t3')}</Text>
                              </Box>
                              <Box w="25%">
                                <Text mx="2">{t('recording.table.t4')}</Text>
                              </Box>
                            </Stack>
                            {isLoadingMedicalRecords ? (
                              <Center p="6">
                                <Spinner color="blue" />
                              </Center>
                            ) : (
                              <Accordion
                                index={arrayOpenTabs}
                                allowMultiple
                                w="100%"
                                position="relative"
                              >
                                {medicalRecords?.map((record, index) => (
                                  <AccordionItem key={record?.attendance_id || `record${index}`}>
                                    {({ isExpanded }) => (
                                      <>
                                        <h2>
                                          <AccordionButton
                                            _expanded={{
                                              bg: 'blue.500',
                                              color: 'white'
                                            }}
                                            justifyContent="space-around"
                                            alignItems="center"
                                          >
                                            <Flex
                                              flex="1"
                                              ml="4px"
                                              dir="row"
                                              justifyContent="space-around"
                                              alignItems="center"
                                            >
                                              <Box w="25%">
                                                <Text fontSize="14px" fontWeight="hairline" mx="2">
                                                  {dateFormat(record?.finish_date)}
                                                </Text>
                                              </Box>
                                              <Box w="25%">
                                                <Text fontSize="14px" fontWeight="hairline">
                                                  {record?.specialist?.social_name}
                                                </Text>
                                              </Box>
                                              <Box w="25%">
                                                <List
                                                  spacing={2}
                                                  textAlign="left"
                                                  justifyContent="flex-start"
                                                >
                                                  {record?.services_performed?.map((service) => (
                                                    <ListItem key={service?.service_id}>
                                                      <Tooltip
                                                        label={service.service_name}
                                                        aria-label={service.service_name}
                                                      >
                                                        <Text
                                                          fontSize="sm"
                                                          fontWeight="hairline"
                                                          noOfLines={1}
                                                          _hover={{
                                                            cursor: 'default'
                                                          }}
                                                        >
                                                          {`${service?.service_name} - 1/${service?.total_session}`}
                                                        </Text>
                                                      </Tooltip>
                                                    </ListItem>
                                                  ))}
                                                  {record?.sessions?.map((service, index) => (
                                                    <ListItem
                                                      key={`${service?.service_id}${index}`}
                                                    >
                                                      <Tooltip
                                                        label={service.service_name}
                                                        aria-label={service.service_name}
                                                      >
                                                        <Text
                                                          fontSize="sm"
                                                          fontWeight="hairline"
                                                          noOfLines={1}
                                                          _hover={{
                                                            cursor: 'default'
                                                          }}
                                                        >
                                                          {`${service?.service_name} - ${service?.session_number}/${service?.total_session}`}
                                                        </Text>
                                                      </Tooltip>
                                                    </ListItem>
                                                  ))}
                                                  {record?.services_performed?.length === 0 &&
                                                    record?.sessions?.length === 0 &&
                                                    record?.attendance_id !== 0 && <Text>---</Text>}
                                                  {record?.services_performed?.length === 0 &&
                                                    record?.sessions?.length === 0 &&
                                                    record?.attendance_id === 0 && (
                                                      <Text>
                                                        {t('recording.recordNoAttendance')}
                                                      </Text>
                                                    )}
                                                </List>
                                              </Box>
                                              <Flex gap={2} flexDirection="row" w="25%">
                                                <Box>
                                                  <Text fontSize="12" fontWeight="hairline">
                                                    {t('recording.forms')}
                                                  </Text>
                                                  <Text
                                                    fontSize="14px"
                                                    fontWeight="hairline"
                                                    mx="2"
                                                  >
                                                    {record?.forms?.length || 0}
                                                  </Text>
                                                </Box>
                                                <Box>
                                                  <Text fontSize="12" fontWeight="hairline">
                                                    {t('recording.prescriptions')}
                                                  </Text>
                                                  <Text
                                                    fontSize="14px"
                                                    fontWeight="hairline"
                                                    mx="2"
                                                  >
                                                    {record?.prescriptions?.length || 0}
                                                  </Text>
                                                </Box>
                                                <Box>
                                                  <Text fontSize="12" fontWeight="hairline">
                                                    {t('recording.exams')}
                                                  </Text>
                                                  <Text
                                                    fontSize="14px"
                                                    fontWeight="hairline"
                                                    mx="2"
                                                  >
                                                    {record?.exams?.length || 0}
                                                  </Text>
                                                </Box>
                                                <Box>
                                                  <Text fontSize="12" fontWeight="hairline">
                                                    {t('recording.indications')}
                                                  </Text>
                                                  <Text
                                                    fontSize="14px"
                                                    fontWeight="hairline"
                                                    mx="2"
                                                  >
                                                    {record?.indications?.length || 0}
                                                  </Text>
                                                </Box>
                                              </Flex>
                                            </Flex>
                                            {isExpanded ? (
                                              <MinusIcon fontSize="12px" />
                                            ) : (
                                              <AddIcon fontSize="12px" />
                                            )}
                                          </AccordionButton>
                                        </h2>
                                        <AccordionPanel
                                          borderRadius="4px"
                                          border="1px solid #d3d3d3"
                                          position="relative"
                                        >
                                          <Flex px="10" py="4">
                                            <Flex my="2" justifyContent="flex-end">
                                              <Box position="absolute" top="2" right="2">
                                                {Number(decodeToken.user_id) ===
                                                  record?.specialist?.id &&
                                                  returnValidateViewButtonAddMedicalRecord(
                                                    record.finish_date
                                                  ) &&
                                                  decodeToken?.clinic
                                                    ?.adding_itens_to_attendance === true &&
                                                  record?.attendance_id !== 0 && (
                                                    <AddRecordUniq
                                                      id={record?.attendance_id}
                                                      updateListRecording={
                                                        getAllMedicalRecordsValues
                                                      }
                                                      servicesList={servicesIndications}
                                                    />
                                                  )}
                                              </Box>
                                            </Flex>
                                            <Flex
                                              flex="1"
                                              alignItems="flex-start"
                                              justifyContent="flex-start"
                                              flexDirection="column"
                                              p="2"
                                              mt="2"
                                            >
                                              {verifyTitleIsView(record) && (
                                                <Text
                                                  fontSize="lg"
                                                  fontWeight="bold"
                                                  fontFamily="heading"
                                                  mb="2"
                                                >
                                                  {t('recording.noServices')}
                                                </Text>
                                              )}
                                              <Flex w="100%">
                                                <List spacing={2}>
                                                  {record?.services_not_performed?.map(
                                                    (service) => (
                                                      <ListItem key={service?.service_id}>
                                                        <Flex flexDirection="row">
                                                          <ListIcon
                                                            as={BiErrorCircle}
                                                            color="red.500"
                                                          />
                                                          <Text fontSize="sm" fontWeight="bold">
                                                            {`${service?.service_name} - 1/${
                                                              service?.service?.service_sessions
                                                                ?.length || ''
                                                            }`}
                                                          </Text>
                                                          <Text
                                                            mx="2"
                                                            fontSize="sm"
                                                            fontWeight="hairline"
                                                          >
                                                            {service?.description}
                                                          </Text>
                                                        </Flex>
                                                      </ListItem>
                                                    )
                                                  )}
                                                </List>
                                              </Flex>
                                              <Flex w="100%">
                                                <List spacing={2}>
                                                  {record?.sessions_not_performed?.map(
                                                    (service) => (
                                                      <ListItem
                                                        key={`${service?.service_id}$/{service?.session_number}/${service?.service_id}`}
                                                      >
                                                        <Flex flexDirection="row">
                                                          <ListIcon
                                                            as={BiErrorCircle}
                                                            color="red.500"
                                                          />
                                                          <Text fontSize="sm" fontWeight="bold">
                                                            {`${service?.service_name} - ${service.session_number}/${service?.total_session}`}
                                                          </Text>
                                                          <Text
                                                            mx="2"
                                                            fontSize="sm"
                                                            fontWeight="hairline"
                                                          >
                                                            {service?.description}
                                                          </Text>
                                                        </Flex>
                                                      </ListItem>
                                                    )
                                                  )}
                                                </List>
                                              </Flex>
                                              {record?.forms?.map((form, indexForm) => (
                                                <Flex
                                                  p="2"
                                                  key={indexForm}
                                                  my="2"
                                                  borderRadius={8}
                                                  border="1px solid gray"
                                                  position="relative"
                                                  flexDirection="column"
                                                  w="100%"
                                                >
                                                  <Box position="absolute" top="2" right="2">
                                                    <PrintButton
                                                      id={form?.id}
                                                      typePrint="form"
                                                      templates={templates}
                                                      patientId={params.id}
                                                      isHaveAttendance={record?.attendance_id !== 0}
                                                      recordId={record?.id}
                                                    />
                                                  </Box>
                                                  <Text
                                                    fontSize="lg"
                                                    fontWeight="bold"
                                                    fontFamily="heading"
                                                    mb="2"
                                                    key={`${form?.name}${indexForm}`}
                                                  >
                                                    {t('recording.form')}
                                                  </Text>
                                                  <Flex w="100%" flexDirection="column" gap={2}>
                                                    <Text>
                                                      {form?.name === 'Blank'
                                                        ? ''
                                                        : `${form?.name}`}
                                                    </Text>
                                                    {htmlToElement(form?.information || '')}
                                                    {form?.questions?.map((question) => (
                                                      <Box key={question?.question}>
                                                        <Text>{question?.question}</Text>
                                                        <Text
                                                          mx="4"
                                                          fontSize="14px"
                                                          fontWeight="hairline"
                                                        >
                                                          {t('recording.answer')}
                                                          {question?.answer}
                                                        </Text>
                                                      </Box>
                                                    ))}
                                                  </Flex>
                                                </Flex>
                                              ))}
                                              {record?.prescriptions?.map(
                                                (prescription, indexPres) => (
                                                  <Flex
                                                    p="2"
                                                    my="2"
                                                    key={prescription.id || indexPres}
                                                    borderRadius={8}
                                                    position="relative"
                                                    border="1px solid gray"
                                                    flexDirection="column"
                                                    w="100%"
                                                  >
                                                    <Box position="absolute" top="2" right="2">
                                                      <PrintButton
                                                        id={prescription?.id || prescription?.name}
                                                        typePrint="prescription"
                                                        templates={templates}
                                                        patientId={params.id}
                                                        isHaveAttendance={
                                                          record?.attendance_id !== 0
                                                        }
                                                        recordId={record?.id}
                                                      />
                                                    </Box>
                                                    <Text
                                                      fontSize="lg"
                                                      fontWeight="bold"
                                                      fontFamily="heading"
                                                      mb="2"
                                                      key={`${prescription?.name}${indexPres}`}
                                                    >
                                                      {t('recording.prescription')}
                                                    </Text>
                                                    <Flex w="100%" flexDirection="column" gap={2}>
                                                      {prescription?.name === 'Blank'
                                                        ? ''
                                                        : `${prescription?.name}`}
                                                      {htmlToElement(
                                                        prescription?.information || ''
                                                      )}
                                                    </Flex>
                                                  </Flex>
                                                )
                                              )}
                                              {record?.exams?.map((exam, indexExam) => (
                                                <Flex
                                                  p="2"
                                                  my="2"
                                                  key={exam.id || indexExam}
                                                  borderRadius={8}
                                                  position="relative"
                                                  border="1px solid gray"
                                                  flexDirection="column"
                                                  w="100%"
                                                >
                                                  <Box position="absolute" top="2" right="2">
                                                    <PrintButton
                                                      id={exam?.id || exam?.name}
                                                      typePrint="exam"
                                                      templates={templates}
                                                      patientId={params.id}
                                                      isHaveAttendance={record?.attendance_id !== 0}
                                                      recordId={record?.id}
                                                    />
                                                  </Box>
                                                  <Text
                                                    fontSize="lg"
                                                    fontWeight="bold"
                                                    fontFamily="heading"
                                                    mb="2"
                                                    key={`${exam?.name}${indexExam}`}
                                                  >
                                                    {t('recording.exam')}
                                                  </Text>
                                                  <Flex w="100%" flexDirection="column" gap={2}>
                                                    {exam?.name === 'Blank' ? '' : `${exam?.name}`}
                                                    {htmlToElement(exam?.information || '')}
                                                  </Flex>
                                                </Flex>
                                              ))}
                                              {record?.indications &&
                                                record?.indications?.length > 0 && (
                                                  <List
                                                    p="2"
                                                    w="100%"
                                                    border="1px solid gray"
                                                    rounded="md"
                                                    mt="2"
                                                    position="relative"
                                                    spacing={2}
                                                  >
                                                    <Text
                                                      fontSize="lg"
                                                      fontWeight="bold"
                                                      fontFamily="heading"
                                                      mb="2"
                                                    >
                                                      {t('recording.indications')}
                                                    </Text>
                                                    <Box position="absolute" top="2" right="2">
                                                      <PrintButton
                                                        id={record?.attendance_id}
                                                        typePrint="indication"
                                                        templates={templates}
                                                        patientId={params.id}
                                                        isHaveAttendance={
                                                          record?.attendance_id !== 0
                                                        }
                                                        recordId={record?.id}
                                                      />
                                                    </Box>
                                                    {record?.indications
                                                      ?.sort((a, b) => {
                                                        return (
                                                          new Date(
                                                            a?.indication_date || ''
                                                          ).getTime() -
                                                          new Date(
                                                            b?.indication_date || ''
                                                          ).getTime()
                                                        )
                                                      })
                                                      .map((ind, indexInd) => (
                                                        <ListItem w="100%" key={ind?.id}>
                                                          <Flex
                                                            w="100%"
                                                            textAlign="left"
                                                            flexDirection="column"
                                                          >
                                                            <Flex gap="2" flexDir="row">
                                                              <ListIcon
                                                                as={MdSettingsAccessibility}
                                                                color="gray"
                                                              />
                                                              <Text fontSize="sm" fontWeight="bold">
                                                                {ind?.service_name}
                                                              </Text>
                                                              {ind?.indication_date && (
                                                                <Text
                                                                  fontSize="sm"
                                                                  fontWeight="bold"
                                                                >
                                                                  {`- ${format(
                                                                    new Date(
                                                                      Number(
                                                                        ind?.indication_date.substring(
                                                                          0,
                                                                          4
                                                                        )
                                                                      ),
                                                                      Number(
                                                                        ind?.indication_date.substring(
                                                                          5,
                                                                          7
                                                                        )
                                                                      ) - 1,
                                                                      Number(
                                                                        ind?.indication_date.substring(
                                                                          8,
                                                                          10
                                                                        )
                                                                      )
                                                                    ),
                                                                    'dd/MM/yyyy'
                                                                  )}`}
                                                                </Text>
                                                              )}
                                                            </Flex>
                                                            <Text
                                                              mx="2"
                                                              ml="8"
                                                              fontSize="sm"
                                                              fontWeight="hairline"
                                                            >
                                                              {ind?.observation}
                                                            </Text>
                                                          </Flex>
                                                        </ListItem>
                                                      ))}
                                                  </List>
                                                )}
                                            </Flex>
                                          </Flex>
                                        </AccordionPanel>
                                      </>
                                    )}
                                  </AccordionItem>
                                ))}
                              </Accordion>
                            )}
                          </Flex>
                        </>
                        <Flex w="100%" h="400px" />
                      </Flex>
                    )}
                  </Flex>
                </>
              </TabPanel>
              <TabPanel>
                <>
                  <Flex flex="1" flexDirection="column">
                    <Flex
                      w="100%"
                      borderBlockEnd="1px solid #e4e4e4"
                      mb="2"
                      pb="2"
                      alignItems="flex-end"
                      mx="auto"
                    >
                      <Flex flexDirection="row" alignItems="flex-end">
                        <Stack direction="row" alignItems="flex-end">
                          <Box w="250px">
                            <Select
                              name="listBy"
                              options={[
                                {
                                  value: 'indication_date',
                                  label: `${t('indications.table.t1')}`
                                },
                                {
                                  value: 'medical_record__finish_date',
                                  label: `${t('indications.table.t2')}`
                                }
                              ]}
                              value={listByIndication}
                              onChange={(e) => setListByIndication(e.target.value)}
                              label="Listar por:"
                              mb="0"
                            />
                          </Box>
                          <Box w="250px">
                            <Select
                              name="orderer"
                              options={[
                                { value: '', label: 'Crescente' },
                                { value: '-', label: 'Decrescente' }
                              ]}
                              label="Ordenar por:"
                              mb="0"
                              value={orderByIndication}
                              onChange={(e) => setOrderByIndication(e.target.value)}
                            />
                          </Box>
                          <MultiSelectMenuFilter
                            label="Especialistas"
                            options={clientService.specialists.map((specialist) => {
                              return {
                                id: String(specialist?.user?.id),
                                name: specialist?.social_name || specialist.user.name
                              }
                            })}
                            backChange={(values: any) => {
                              setSpecialistsIndication(values)
                            }}
                          />
                          <MultiSelectMenuFilter
                            label="Status"
                            options={statusOptionsIndications.map((itemStatus) => {
                              return {
                                id: String(itemStatus.value),
                                name: itemStatus.label
                              }
                            })}
                            backChange={(values: any) => {
                              setStatusIndication(values)
                            }}
                          />

                          <Button
                            size="md"
                            bg="blue.300"
                            color="white"
                            isLoading={isLoadingIndications}
                            onClick={() => {
                              const filters = {
                                specialistIds: specialistsIndication,
                                status: statusIndication,
                                orderBy: `${orderByIndication}${listByIndication}`
                              }

                              setFiltersIndication(filters)
                            }}
                          >
                            Aplicar
                          </Button>
                        </Stack>
                      </Flex>
                    </Flex>
                    {/* content indications */}
                    <Flex flex="1" h="100vh" flexDirection="column">
                      {isLoadingIndications ? (
                        <Center w="100%" p="2">
                          <Spinner size="md" color="blue" />
                        </Center>
                      ) : (
                        <>
                          <Table variant="striped" colorScheme="blue" size="sm">
                            <Thead>
                              <Tr>
                                <Th>{t('indications.table.t1')}</Th>
                                <Th>{t('indications.table.t2')}</Th>
                                {specialistIds.length === 1 ? null : (
                                  <Th w="200px">{t('indications.table.t3')}</Th>
                                )}
                                <Th>{t('indications.table.t4')}</Th>
                                <Th>{t('indications.table.t7')}</Th>
                                <Th>{t('indications.table.t8')}</Th>
                                <Th>{t('indications.table.t9')}</Th>
                                <Th>{t('indications.table.t10')}</Th>
                                <Th>{t('indications.table.t11')}</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {indicationsData?.length > 0 &&
                                !isLoadingIndications &&
                                indicationsData?.map((ind, indexInd) => (
                                  <Tr key={`${ind.service_name}${indexInd}`}>
                                    <Td>
                                      {ind?.indication_date ? (
                                        format(
                                          new Date(
                                            Number(ind?.indication_date.substring(0, 4)),
                                            Number(ind?.indication_date.substring(5, 7)) - 1,
                                            Number(ind?.indication_date.substring(8, 10))
                                          ),
                                          'dd/MM/yyyy',
                                          {
                                            locale: LocaleApp
                                          }
                                        )
                                      ) : (
                                        <Text>--/--/----</Text>
                                      )}
                                    </Td>
                                    <Td>
                                      {ind?.medical_record_finish_date ? (
                                        format(
                                          new Date(ind?.medical_record_finish_date),
                                          'dd/MM/yyyy',
                                          {
                                            locale: LocaleApp
                                          }
                                        )
                                      ) : (
                                        <Text>--/--/----</Text>
                                      )}
                                    </Td>
                                    {specialistIds.length === 1 ? null : (
                                      <Td>
                                        <Text>{ind?.specialist_name}</Text>
                                      </Td>
                                    )}
                                    <Td>
                                      <Tooltip
                                        aria-label={ind?.service_name}
                                        label={ind?.service_name}
                                      >
                                        <Box>
                                          <Text noOfLines={1} _hover={{ cursor: 'default' }}>
                                            {ind?.service_name}
                                          </Text>
                                        </Box>
                                      </Tooltip>
                                    </Td>
                                    <Td>
                                      <Tooltip
                                        aria-label={ind?.observation || ''}
                                        label={ind?.observation || ''}
                                      >
                                        <Box>
                                          <Text noOfLines={1} _hover={{ cursor: 'default' }}>
                                            {ind?.observation}
                                          </Text>
                                        </Box>
                                      </Tooltip>
                                    </Td>
                                    <Td>
                                      {ind?.status === 1 && (
                                        <Text>{t('indications.status.1')}</Text>
                                      )}
                                      {ind?.status === 2 && (
                                        <Text>{t('indications.status.2')}</Text>
                                      )}
                                      {ind?.status === 3 && (
                                        <Text>{t('indications.status.3')}</Text>
                                      )}
                                      {ind?.status === 4 && (
                                        <Text>{t('indications.status.4')}</Text>
                                      )}
                                      {ind?.status === 5 && (
                                        <Text>{t('indications.status.5')}</Text>
                                      )}
                                    </Td>
                                    <Td>
                                      {ind?.updated_at ? (
                                        format(new Date(ind?.updated_at), 'dd/MM/yyyy')
                                      ) : (
                                        <Text>--/--/----</Text>
                                      )}
                                    </Td>
                                    <Td>
                                      <Text>{ind?.updated_by_name || '---'}</Text>
                                    </Td>
                                    <Td>
                                      {ind?.status === 1 && (
                                        <Tooltip aria-label="Editar" label="Editar">
                                          <Box>
                                            <FiEdit
                                              onClick={() => {
                                                setObservationInd(ind?.observation || '')
                                                setIdIndication(ind?.id)
                                                setIdServiceIndication(ind?.service?.id)
                                                setDateIndication(
                                                  ind?.indication_date?.substring(0, 10) ||
                                                    format(new Date(), 'dd/MM/yyyy', {
                                                      locale: LocaleApp
                                                    })
                                                )
                                                setStatusChangeIndication(ind?.status)
                                                setIsOpenEditIndication(true)
                                              }}
                                              color="#9699B0"
                                              size={16}
                                              style={{ cursor: 'pointer' }}
                                            />
                                          </Box>
                                        </Tooltip>
                                      )}
                                    </Td>
                                  </Tr>
                                ))}
                            </Tbody>
                          </Table>
                          {isLoadingIndications && (
                            <Flex justifyContent="center" alignItems="center" w="100%" p="8">
                              <Spinner size="md" color="blue" />
                            </Flex>
                          )}
                          {totalOfRegisterIndication === 0 && !isLoadingIndications && <NotFound />}
                          {totalOfRegisterIndication !== 0 && !isLoadingIndications && (
                            <Pagination
                              totalCountOfRegisters={totalOfRegisterIndication}
                              currentPage={currentPageIndication}
                              onPageChange={setCurrentPageIndication}
                            />
                          )}
                        </>
                      )}
                      <Flex w="100%" h="400px" />
                    </Flex>
                  </Flex>
                  <ModalArrivedTime
                    isOpen={isOpenEditIndication}
                    isLoading={isLoadingIndications}
                    title="Edição de indicação"
                    onClose={() => setIsOpenEditIndication(false)}
                    onUpdate={async () => {
                      await handlerUpdateIndication()
                    }}
                  >
                    <Stack direction="column" w="100%">
                      <Input
                        name="dateIndication"
                        value={dateIndication}
                        isRequired
                        label={t('indications.table.t1')}
                        onChange={(e) => {
                          if (e.target.value !== '') {
                            setDateIndication(e.target.value)
                          }
                        }}
                        type="date"
                        min={format(new Date(), 'yyyy-MM-dd')}
                      />
                      <Flex gap="2" flexDir="column">
                        <Text fontSize="14px">Comentário</Text>
                        <Textarea
                          name="observationInd"
                          value={observationInd || ''}
                          onChange={(e) => setObservationInd(e.target.value)}
                        />
                      </Flex>
                      <Select
                        label="Status"
                        name="newStatusInd"
                        value={statusChangeIndication}
                        options={statusOptionsIndicationsEdit}
                        onChange={(e) => setStatusChangeIndication(Number(e.target.value))}
                      />
                      <Stack direction="row">
                        <FiInfo />
                        <Text fontSize="xs" fontWeight="hairline">
                          Ao alterar o status para rejeitado ou cancelado, não é possível desfazer a
                          alteração ou editar o item novamente.
                        </Text>
                      </Stack>
                    </Stack>
                  </ModalArrivedTime>
                </>
              </TabPanel>
              <TabPanel>
                <>
                  <Flex flex="1" flexDirection="column">
                    <Flex
                      w="100%"
                      borderBlockEnd="1px solid #e4e4e4"
                      mb="2"
                      pb="2"
                      alignItems="flex-end"
                      mx="auto"
                    >
                      <Flex w="100%" flexDirection="row" alignItems="flex-end">
                        <Stack w="100%" direction="row" alignItems="flex-end">
                          <Box w="320px">
                            <Input
                              name="dateBudgets"
                              type="date"
                              label={t('budgets.labels.searchDate')}
                              value={dateBudgets}
                              onChange={(event) => setDateBudgets(event.target.value)}
                            />
                          </Box>

                          <MultiSelectMenuFilter
                            label="Especialistas"
                            options={clientService.specialists.map((specialist) => {
                              return {
                                id: String(specialist?.user?.id),
                                name: specialist?.social_name || specialist.user.name
                              }
                            })}
                            backChange={(values: any) => {
                              setSpecialistsBudgets(values)
                            }}
                          />

                          <Button
                            size="md"
                            bg="blue.300"
                            color="white"
                            isLoading={isLoadingBudgets}
                            onClick={() => {
                              setFiltersBudgets({
                                date: dateBudgets,
                                specialistIds: specialistsBudgets
                              })
                            }}
                          >
                            Aplicar
                          </Button>
                          <Button
                            size="md"
                            bg="blue.300"
                            color="white"
                            isLoading={isLoadingBudgets}
                            onClick={() => {
                              history.push('/budgets/create', {
                                id: params.id,
                                name: state?.name
                              })
                            }}
                          >
                            {t('budgets.newBudgets')}
                          </Button>
                        </Stack>
                      </Flex>
                    </Flex>
                    {/* content budgets */}
                    <Flex flex="1" h="100vh" flexDirection="column">
                      {isLoadingBudgets ? (
                        <Center w="100%" p="2">
                          <Spinner size="md" color="blue" />
                        </Center>
                      ) : (
                        <>
                          <Table variant="striped" colorScheme="blue" size="sm">
                            <Thead>
                              <Tr>
                                <Th>{t('budgets.table.t1')}</Th>
                                <Th>{t('budgets.table.t2')}</Th>
                                <Th>{t('budgets.table.t3')}</Th>
                                {specialistIds.length === 1 ? null : (
                                  <Th w="200px">{t('budgets.table.t4')}</Th>
                                )}
                                <Th>{t('budgets.table.t7')}</Th>
                                <Th>{t('budgets.table.t8')}</Th>
                                <Th>{t('budgets.table.t9')}</Th>
                                <Th>{t('budgets.table.t10')}</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {budgetsData?.map((bud) => (
                                <Tr key={bud.id || bud?.code}>
                                  <Td>{bud?.code}</Td>
                                  <Td>{format(new Date(bud?.created_at), 'dd/MM/yyy')}</Td>
                                  <Td>
                                    {bud.due_date ? (
                                      format(
                                        new Date(
                                          Number(bud.due_date.substring(0, 4)),
                                          Number(bud.due_date.substring(5, 7)) - 1,
                                          Number(bud.due_date.substring(8, 10))
                                        ),
                                        'dd/MM/yyyy',
                                        {
                                          locale: LocaleApp
                                        }
                                      )
                                    ) : (
                                      <Text>--/--/----</Text>
                                    )}
                                  </Td>
                                  <Td>{bud?.specialist ? bud?.specialist?.social_name : '---'}</Td>
                                  <Td w="230px">
                                    {bud?.items !== undefined &&
                                      bud?.items?.map((service) => (
                                        <Tooltip
                                          key={service.id}
                                          label={service.service_name || ''}
                                          aria-label={service.service_name || ''}
                                          hasArrow
                                          placement="top-start"
                                        >
                                          <Text
                                            noOfLines={1}
                                            key={service.id}
                                            fontSize="12px"
                                            fontWeight="semibold"
                                            _hover={{
                                              cursor: 'default'
                                            }}
                                          >
                                            {service?.service_name}
                                          </Text>
                                        </Tooltip>
                                      ))}
                                  </Td>
                                  <Td textAlign="right">
                                    {formatBrOrDollarDefault(bud?.total?.toFixed(2))}
                                  </Td>
                                  <Td>{bud?.created_by?.social_name}</Td>
                                  <Td>
                                    <Flex
                                      alignItems="center"
                                      justifyContent="center"
                                      textAlign="center"
                                      flexDir="row"
                                      gap={2}
                                    >
                                      <Box>
                                        <PrintButton
                                          id={bud?.id}
                                          patientId={params?.id}
                                          isIconButton
                                          templates={templates}
                                          typePrint="quotes"
                                          nameDocument={state?.social_name}
                                          code={bud?.code}
                                        />
                                      </Box>
                                      <Link
                                        to={{
                                          pathname: `/budgets/create`,
                                          state: {
                                            id: params.id,
                                            name: state?.name,
                                            budget: bud
                                          }
                                        }}
                                      >
                                        <Tooltip
                                          label="Usar como base"
                                          aria-label="usar como base"
                                          hasArrow
                                          placement="top-start"
                                        >
                                          <Box w="24px">
                                            <FiEdit
                                              color="#9699B0"
                                              size={16}
                                              style={{ cursor: 'pointer' }}
                                            />
                                          </Box>
                                        </Tooltip>
                                      </Link>
                                    </Flex>
                                  </Td>
                                </Tr>
                              ))}
                            </Tbody>
                          </Table>
                          {isLoadingBudgets && (
                            <Flex justifyContent="center" alignItems="center" w="100%" p="8">
                              <Spinner size="md" color="blue" />
                            </Flex>
                          )}
                          {totalOfRegisterBudgets === 0 && !isLoadingBudgets && <NotFound />}
                          {totalOfRegisterBudgets !== 0 && !isLoadingBudgets && (
                            <Pagination
                              totalCountOfRegisters={totalOfRegisterBudgets}
                              currentPage={currentPageBudgets}
                              onPageChange={setCurrentPageBudgets}
                            />
                          )}
                        </>
                      )}
                      <Flex w="100%" h="400px" />
                    </Flex>
                  </Flex>
                </>
              </TabPanel>
              <TabPanel>
                <>
                  <Flex flex="1" flexDirection="column">
                    {/* control */}
                    <Flex
                      w="100%"
                      borderBlockEnd="1px solid #e4e4e4"
                      mb="2"
                      pb="2"
                      align="flex-start"
                      justify="space-between"
                      mx="auto"
                    >
                      <Flex flexDirection="row">
                        {isWideVersion ? (
                          <Heading size="md">{t('gallery.title')}</Heading>
                        ) : (
                          <Heading size="md">{t('gallery.titleMobile')}</Heading>
                        )}
                      </Flex>
                      <Flex flexDirection="row">
                        <Button
                          mx="2"
                          colorScheme="blue"
                          size="sm"
                          onClick={() => {
                            setTypeCard('gallery')
                            handleCreateNewCardOpenModal()
                          }}
                        >
                          {t('btnNew')}
                        </Button>
                      </Flex>
                    </Flex>
                    {/* content imagens / videos */}
                    <Center flex="1" p="2" h="100vh">
                      {galleryCard && !galleryIsLoading && !galleryError && (
                        <VStack w="100%">
                          {galleryCard.map((card) => (
                            <Flex w="100%" key={card.id}>
                              <Card
                                onClick={() => handlerClickInCardToUpdate(card.id)}
                                isMedia
                                date={card.date}
                                title={card.name}
                                photosQuantity={card.quantity_images}
                                mediaQuantity={card.quantity_videos}
                                documentsQuantity={card?.quantity_documents}
                              />
                            </Flex>
                          ))}
                        </VStack>
                      )}
                      {galleryCard && !galleryIsLoading && galleryError && (
                        <Text fontSize="12px" color="#999">
                          {t('gallery.galleryError')}
                        </Text>
                      )}
                      {galleryCard === null && !galleryIsLoading && !galleryError && (
                        <Flex>
                          <NotFound />
                        </Flex>
                      )}
                      {galleryIsLoading && (
                        <Flex direction="row">
                          <Text mx="4" fontSize="12px" color="#999">
                            {t('gallery.isLoading')}
                          </Text>
                          <Spinner size="md" color="blue" />
                        </Flex>
                      )}
                    </Center>
                  </Flex>
                  <ModalCreateNewCard
                    isOpen={newCardIsOpen}
                    onClose={() => handleCreateNewCardCloseModal()}
                    onCreate={() => {
                      handlerCreateNewCard()
                    }}
                    title={t('modalCreateCard.title')}
                  >
                    <Flex w="320px" flexDirection="column" p="2" mx="auto">
                      <VStack spacing="6">
                        <TextFieldControlled
                          name="dateCard"
                          type="date"
                          initialValue={dateCard}
                          textAlign="left"
                          isRequired
                          onChange={(event) => setDateCard(event.target.value)}
                          label={t('modalCreateCard.dateCard')}
                        />
                        <TextFieldControlled
                          name="nameCard"
                          initialValue={nameCard}
                          textAlign="left"
                          placeholder=""
                          isRequired
                          onChange={(event) => setNameCard(event.target.value.toUpperCase())}
                          label={t('modalCreateCard.nameCard')}
                        />
                      </VStack>
                    </Flex>
                  </ModalCreateNewCard>
                  <ModalConfirmExclude
                    isOpen={isOpenCancel}
                    onClose={() => setIsOpenCancel(false)}
                    onConfirmExclude={() => {
                      handlerCancelSessionById(idSession)
                    }}
                    title={t('modalCancelSession.title')}
                  >
                    <Flex w="320px" flexDirection="column" p="2" mx="auto">
                      <VStack spacing="6">
                        <Textarea
                          name="nameCard"
                          value={descriptionSession}
                          textAlign="left"
                          placeholder={t('modalCancelSession.placeholder')}
                          isRequired
                          onChange={(event) => setDescriptionSession(event.target.value)}
                        />
                      </VStack>
                    </Flex>
                  </ModalConfirmExclude>
                </>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
        <ModalWebcam title={t('modal.title')} isOpen={isOpen} onClose={handleCloseModal}>
          <Flex mx="2px" h="500px">
            <WebcamCapture onImageCaptured={handleUploadPatientImage} />
          </Flex>
        </ModalWebcam>
        <ModalConfirmExclude
          title={`${t('warning')}`}
          isOpen={isOpenChangeMessage}
          onClose={() => setIsOpenChangeMessage(false)}
          onConfirmExclude={() => setIsOpenChangeMessage(false)}
          isLoadingOnSave={isLoadingOperation}
          onSave={async () => {
            await handleUpdateClientOnSave()
            setMessageChangeForSave(false)
          }}
          outNotSave={() => {
            history?.goBack()
          }}
          isButtonOff
        >
          <Text>{`${t('messageChange')}`}</Text>
        </ModalConfirmExclude>
      </>
    </Box>
  )
}
